import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

// 退款弹窗
import transactionRefundDialogZh from '@/views/transaction/transaction-details/components/refundDialog/locale/zh-cn.js';

export default {
  message: {
    lang: {
      'zh-cn': '中文',
      en: 'English',
    },
    ...transactionRefundDialogZh,
    index: {
      index: '首页',
      welcome: '你好, {user}',
      pending: '待处理事项',
      untreatedRefuseTransaction: '未处理拒付交易',
      untreatedAdjustmentTransaction: '未处理调单交易',
      overview: '概览',
      transactionSuccessRate: '交易成功率',
      transactionSuccessToday: '今日成功交易',
      transactionRefuseToday: '今日拒付交易',
      transactionCount: '{count}笔',
      transactionAmount7Day: '七日交易总额',
      transactionCount7Day: '七日交易总笔数',
      transactionSummary: '交易概要',
      refuseAmount7Day: '七日拒付总额',
      refuseCount7Day: '七日拒付总笔数',
      amount: '金额',
      count: '笔数',
      welcomeTo: '欢迎使用商户系统',
      businessGoals: '多种支付方案使您能够实现业务目标。',
      provides: '为您提供一站式付款模式，使您能够轻松接收来自世界各地的在线订单。帮助您在全球拓展业务，开拓新市场',
      attentionTip: '为了避免您的损失，请及时处理退单',
      newRefuseTxn: '新增的拒付交易',
      refuseTxnTitle: '拒付交易',
      new: '新增',
      appealFailed: '首次抗辩失败',
      countUnit: '笔',
      refuseTxn: '拒付交易（首次抗辩失败）',
      transaction: '交易概览',
      doMore: '更多',
      addTeamOperator: '新增操作员',
      websiteManagement: '应用列表',
      sendMoney: '付款',
      successTxnAmount: '成功交易金额',
      successTxnAmountTip: '当前币种成功交易金额',
      successTxnCount: '成功交易笔数',
      successTxnCountTip: '当前币种成功交易笔数',
      chargebackAmount: '拒付交易金额',
      chargebackAmountTip: '当前币种拒付交易金额',
      refuseCount: '拒付交易笔数',
      refuseCountTip: '当前币种拒付交易笔数',
      last7Days: '近7天',
      last30Days: '近30天',
      noPermission: '当前账户无权查',
      successTxn: '成功交易',
      refuseTxt: '拒付交易',
      successRate: '成功率',
      amountStatistics: '金额统计',
      paidAmount: '已打款金额',
      paidAmountTip: '已打款金额=扣款金额+风控冻结金额',
      totalTxnAmount: '金额',
      totalTxnAmountTip: '交易金额=sale（成功）+capture（成功）+退款（成功）+拒付（新增）+拒付（抗辩成功）的交易金额汇总',
      Upgrading: '功能升级中',
      today: '今日',
      day: '日',
      week: '周',
      month: '月',
      yesterdayTotalAmount: '金额',
      yesterdayTotalAmountTip: '昨天的sale和capture交易的成功总金额；',
      yesterdayTotalCount: '笔数',
      yesterdayTotalCountTip: '昨天的sale和capture交易的成功总笔数；',
      totalTxn: '总交易',
      yesterdayTxn: '昨日交易',
      refuseRate: '拒付率',
      refundRate: '退款率',
      refuseNumber: '拒付笔数',
      refundRateTip: '',
      refuseRateTip: '',
      addOtherCurrency: '开通其他币种账户',
      accountTotalAmount: '账户总额',
      totalAmountTips: '以{currency}估值账户总额（更新于{time}）',
      laterAgain: '请稍后再试',
      open: '开通',
      noTransferTips: '还没有交易哦，快去完成您的第一笔交易吧',
      currencySettings: '币种管理',
      selectCurrencySettings: '请选择需要展示在首页的币种',
      currencyNotHidingTips: '币种余额不为0，不允许隐藏',
    },
    user: {
      forgetPassword: '忘记密码',
      confirmTip: '填写下列信息以便确认您的身份',
      email: '邮箱',
      loginEmail: '登录邮箱',
      contactEmail: '联系邮箱',
      captcha: '验证码',
      sendCaptcha: '获取验证码',
      restTime: '剩余（{time}S）',
      backToLogin: '返回登录',
      loginPassword: '登录密码',
      newPasswordSettingTip: '新密码设置',
      newPasword: '新密码',
      confirmPasword: '再次输入密码',
      login: '登录',
      captchRefresh: '点击图片刷新',
      registerNow: '立即注册',
      noaccount: '还没账号',
      logout: '退出登录',
      updatePassword: '修改密码',
      oldPassword: '原登录密码',
      forgetPwd: '忘记密码',
      forgetPwdTip: '填写以下信息以确认您的身份',
      resetPwdTip: '您的登录邮箱：{email}',
      register: '注册',
      registerTitle: '申请您的ONERWAY账户',
      registerDesc: '遍布全球各地的支付网络，提供快速、低成本、安全的国际付款服务',
      phone: '手机号',
      dynamicCode: '动态验证码',
      supplement: '完善信息',
      supplementTips: '请完善身份认证信息，以便体验完整功能。填写过程中如果离开，您所填写的内容将自动保存草稿，以便后续继续完善',
      supplementMerchantName: '当前认证企业为',
      accountAddress: '账户地址',
      realname: '真实姓名',
      idCard: '身份证号',
      idCardExpire: '身份证有效期',
      longEffective: '长期',
      realnameInfo: '实名信息',
      contactAddress: '联系地址',
      detailAddress: '详细地址',
      detailAddressEn: '详细地址-英文',
      businessRegistration: '企业注册国家/地区',
      merchantName: '公司名称',
      merchantNameEn: '公司名称-英文',
      merchantNameEnTips: '请填写完整的企业英文名称。不允许出现中文字符。',
      merchantRegisterDate: '企业注册日期',
      legalPersonName: '法人姓名',
      legalPersonNumber: '法人身份证号（或身份ID）',
      businessLicense: '营业执照号',
      businessLicenseDate: '营业执照有效期',
      uploadInfo: '需上传信息',
      shareholderInfo: '股东信息',
      shareholderRequire: '*股权超过10%的股东需要提供股东相关信息',
      shareholderName: '股东名称',
      shareholderNameInputTips: '股权大于10%的股东姓名',
      shareholderRatioInputTips: '占股比例',
      shareholderNumber: '股东身份证',
      shareholderNumberDate: '股东身份证有效期',
      shareholderMaterial: '股东资料',
      deleteShareholder: '删除股东',
      addShareholder: '新增股东',
      companyInformation: '企业信息',
      legalInformation: '法人信息',
      pleaseCompleteLegalInformation: '请完善法人信息',
      pleaseUploadMaterial: '请上传必要的资料信息',
      failedToObtainTheMaterial: '未获取到材料项，请稍后再试',
      pleaseContinue: '请继续完善信息，以便完成注册',
      pleaseSelectBusinessType: '请选择注册的业务类型',
      acquiring: '收单',
      payout: '付款',
      collection: '收款',
      functionDevelopment: '功能开发中，请稍后再试',
      personalAccount: '个人账户',
      corporateAccount: '企业账户',
      authentication: '您的实名认证提交成功，我们将为您审核！',
      passwordStrength: '密码强度',
      agreement: '《OnerWay服务协议》',
      agreement1: 'OnerWay服务协议',
      readAgree: '我已阅读并同意',
      agreementTips: '请先阅读并同意《OnerWay服务协议》',
      weak: '弱',
      medium: '中',
      strong: '强',
      alreadyAccount: '已有账号',
      pleaseUploadPortraitSide: '请上传法人身份证人像面',
      pleaseUploadNationalEmblemSide: '请上传法人身份证国徽面',
      uploadImageTips: '确保上传的图片文字清晰可见，最大不超过5M，支持JPG、PNG、BMP、JPEG',
      approving: '审核中',
      passError: '抱歉，当前审核未通过，原因为：',
      contactAddressTips: '该地址主要用来相关材料邮寄、申报证明时使用',
      updateRegisterInfo: '修改注册材料',
      curApplyMerchant: '当前申请企业为：{merchant}',
      globalMerchant: '集团商户',
      acquiringMerchant: '收单商户',
      defaultMerchant: '默认商户',
      collectionMerchant: '收款商户',
      quickRegistration: '快速注册',
      acquiringBusiness: '收单业务',
      collectionsBusiness: '收款业务',
      setDefaultMerchant: '设置默认商户',
      passwordErrorTip: '您的密码已错误{errorNum}次,还剩{successNum}次机会',
      preventAccountLockingTip: '未避免账号锁定,建议通过“忘记密码”设置新的密码',
      usernameOrPasswordError: '用户名或密码错误',
      contactUs: '联系我们',
      privacy: '隐私政策',
      privacy1: '《隐私政策》',
      upgradeTitle: '系统升级-登录地址变更',
      upgradeSubTitle1: '尊敬的客户，由于系统升级，商户端原登录地址将',
      upgradeSubTitle2: '下线',
      upgradeSubTitle3: '请使用新地址登录：',
      upgradeDate: '10月1日',
      upgradeDate1: '',
      upgradeDesc1: '商户端原登录地址：',
      upgradeDesc2: '商户端新登录地址：',
      toNewLoginUrl: '跳转至新地址',
      payPassword: '支付密码',
      newPayPasswrod: '新支付密码',
      payPasswordTip: '您可设置6位数字支付密码，付款时输入',
      settingPayPasswordTip: '请您输入6位数字支付密码并记住支付密码，之后不再显示。如忘记可进行重新设置。',
      emailCode: '邮箱验证码',
      emailCodeTip: '您的注册邮箱将收到6位验证码，付款时输入',
      phoneCode: '手机验证码',
      resetPayPassword: '重新设置支付密码',
      securityTitle: '支付安全设置',
      securityDesc: '支付安全，为您的账户保驾护航！',
      smsNoticeTitle: '动账通知',
      smsNoticeDesc: '动账提醒，财务变动尽在掌握',
      smsNoticeSwitch: '充值、付款等动账短信通知开关',
      phoneNumber: '手机号码',
      registerDoneDesc1: '恭喜！您已完成注册',
      registerDoneDesc2: '页面将在 <span style="color:#00A2DD;">{second}</span> 后跳转至登录页',
      supplementDoneDesc1: '恭喜！您已完成身份认证信息提交。我们将尽快为您审核。',
      supplementDoneDesc2: '页面将在 <span style="color:#00A2DD;">{second}</span> 后返回商户端',
      certificateFileFront: '身份证明文件-正面',
      certificateFileReverse: '身份证明文件-反面',
      businessCertificateFile: '企业注册证书/营业执照',
      businessOtherFile: '其他公司文件',
      goSupplement: '去完善',
      goRevise: '去修改',
      goSupplementTips: '请完善认证信息后再试',
      goReviseTips: '身份认证失败，请修改',
      auditWaitingTips: '身份认证审核中，请等待',
      workAddress: '办公地址',
      operationInfo: '营运信息',
      updatingFiles: '附件上传',
      businessCertificate: '企业证明',
      shareholder: '董事',
      beneficiary: '受益人',
      address: '地址栏',
      webSite: '网站地址',
      webSitePlaceholder: '网站地址，可添加多个，每行一个',
      operationCountry: '业务主要运营国家（多选）',
      fundingSourceCountry: '资金来源国家（多选）',
      targetPaymentCountry: '目标支付国家（多选）',
      monthlyAmount: '预计每月的交易额（以美元计）',
      transactionAmount: '预计单笔平均交易金额（以美元计）',
      bizDescription: '业务描述',
      bizDescriptionPlaceholder: '请描述您的企业和业务，限制200字以内',
      saveTemporary: '临时保存',
      add: '新增+',
      businessCertificationTips: '请上传完整的企业证明文件',
      shareholderTips: '请上传完整的董事证明文件',
      beneficiaryTips: '请上传完整的受益人证明文件',
      authNotCompleted: '当前未完成身份认证，',
      authNotFass: '人脸认证未通过',
      autoNotPendding: '人脸认证审核中',
      jumioNotCompleted: '当前未完成人脸认证，',
      jumioNotCompletedNoicon: '当前未完成人脸认证',
      authReviewing: '身份认证信息，正在审核中',
      authFailed: '身份认证失败，',
      fillInfo: '立即认证',
      modifyInfo: '立即修改',
      backMerchant: '返回商户端',
      saveTemporaryTips: '当前信息已保存，是否返回商户端？',
      stayPage: '留在当前页',
      stayPageSupplement: '留在当前页',
    },
    permission: {
      roleManagement: '角色管理',
      operatorManagement: '操作员管理',
      roleName: '角色名',
      name: '姓名',
      role: '角色',
      resetPassword: '重置密码',
      deleteRoleConfirm: '确认删除此角色',
      deleteUsedRoleConfirm: '该角色还有操作员使用，确认删除该角色',
      editRole: '编辑角色',
      addRole: '新增角色',
      rolePermission: '角色权限',
      rolePermissionTip: '权限设置精确到按钮级别。 如果未选中按钮许可，则操作员无法单击按钮进行操作。 添加权限后，操作员将具有页面和按钮显示以及操作权限。',
      addOperator: '新增操作员',
      addOperatorDesc: '您可以邀请伙伴与您一起管理企业',
      editOperator: '编辑操作员',
      password: '密码',
      passwordRepeat: '重复密码',
      status: '状态',
      permission: '权限',
      roleDetails: '角色详情',
      enableOperatorConfirm: '确认启用操作员',
      disableOperatorConfirm: '确认禁用此操作员',
      newPasword: '新登录密码',
      newPasswordConfirm: '再次输入新密码',
      passwordConfirm: '确认密码',
      admin: '管理员',
      receiveEmail: '接收邮件通知',
    },
    common: {
      requestError: '请求失败',
      blacklistOfSameTypeExist: '存在同类型黑名单库，可直接前往添加值。',
      confirm: '确认',
      clear: '清除',
      unneed: '不用了',
      edit: '编辑',
      save: '保存',
      enable: '启用',
      disable: '禁用',
      enableOperation: '启用',
      disableOperation: '禁用',
      enableOperationText: '启用',
      disableOperationText: '禁用',
      prompt: '提示',
      promptsec: '温馨提示',
      download: '下载',
      add: '添加',
      submit: '提交',
      agree: '同意',
      back: '返回',
      downloadTask: '下载任务已建立，请在下载中心查看',
      more: '更多',
      unlimited: '不限',
      noMatchText: '未找到数据',
      noDataText: '无数据',
      showAll: '查看更多信息',
      optional: '选填',
      next: '下一步',
      previous: '上一步',
      copySuccess: '复制成功',
      reason: '原因',
      have: '有',
      none: '无',
      profile: '简介',
      downloadTemplate: '模板下载',
      finish: '完成',
      jump: '跳过',
      china: '中国',
      hk: '中国香港',
      viewExamples: '查看示例',
      uploadFile: '请上传文件',
      new: '新增',
      addData: '添加数据',
      sort: '排序',
      deleteConfirm: '确认删除该数据',
      packUp: '收起',
      downloadReport: '下载报表',
      disclaimer: '本网站所涉及的收单或收款业务，均由ONERWAY境外展业主体负责海外收款，由合作的境内持牌支付机构[新生支付]在资金跨境环节收汇、结汇。境内收汇、结汇业务将完全直接由新生支付向您提供，您理解并认可ONERWAY并非该部分业务的提供商、总包商、分包商，ONERWAY也不承担该部分业务所引起的和/或与之相关的任何责任。',
      jumpNow: '立即跳转',
      backNow: '立即返回',
      country: '国家',
      province: '省/州',
      city: '城市',
      zipCode: '邮编',
      close: '关闭',
      upload: '上传',
      first6Digits: '前六位',
      last4Digits: '后四位',
      reset: '重置',
      batchOperations: '批量操作',
      import: '导入',
      copy: '复制',
      copied: '已复制',
      dateOptions: {
        Y: '年',
        W: '周',
        M: '月',
        D: '天',
        H: '小时',
      },
      send: '发送',
    },
    validator: {
      required: '必填',
      input: '请输入{input}',
      select: '请选择{select}',
      confirm: '请确认{confirm}',
      upload: '请上传{upload}',
      email: '请输入正确的邮箱',
      passwordRule: '只能包含字母、数字、字符(空格除外)',
      passwordLength: '长度需为8-20位字符',
      passwordStrength: '必须包含 数字+字符+字母',
      passwordConfirm: '需与新密码一致',
      newPasswordConfirm: '不能与原密码相同',
      passwordDiff: '密码不一致',
      stringLength256: '输入长度最大256个字符',
      stringLength50: '输入长度最大50个字符',
      fileCannot: '文件不能大于',
      idCard: '身份证号码不正确',
      inputNumber: '请输入数字',
      cardLength: '长度需大于10位字符',
      inputWords: '仅支持英文或拼音',
      inputEnglish: '仅允许填写英文字母（含大小写）、空格、标点（ . 和 , ）、数字',
      inputPhone: '手机号不正确',
      count: '最多输入{count}个',
      inputLength: '长度需为{length}',
      maxInputLength: '最大长度需为{length}',
      enNumberSpace: '仅允许填写英文字母、数字、空格',
      formatError: '请输入正确的{field}',
      dateFormat: '出生日期格式不正确',
      nameNotEqual: '公司名称和法人名称不一致',
      amount: '必须>=0，小数位最多支持输入两位',
      amount_all: '小数位最多支持输入两位',
      inputNumber1_100: '请输入1~100的数字',
      website: '请输入有效网址',
      inputEmail: '请输入正确的邮箱格式',
    },
    transaction: {
      info: '交易信息',
      detail: '交易详情',
      billingAddress: '账单地址',
      mailingAddress: '邮寄地址',
      integrationMethod: '接入方式',
      name: '姓名',
      zipCode: '邮编',
      thisTransion: '当前交易',
      phone: '电话',
      city: '城市',
      province: '所在州',
      country: '国家',
      address: '地址',
      mandatoryRefund: '退款',
      maximumRefundAmount: '最大退款金额',
      requestRefundAmount: '申请退款金额',
      eciHint: '<div>\n <h3 style="font-size:12px;margin-bottom:8px">ECI：</h3>\n <p>· ECI=00：MasterCard使用。<br>ACS服务不可用或者卡片不支持3D验证；</p>\n                  ' +
        '  <p>· ECI=01：MasterCard使用。<br>持卡人或发卡行未注册3D安全验证服务；</p>\n                 ' +
        '   <p>· ECI=02：MasterCard使用。<br>持卡人3D安全验证通过；</p>\n          ' +
        '          <p>· ECI=05：Visa使用。<br>持卡人3D安全验证通过；</p>\n    ' +
        '                <p>· ECI=06：Visa使用。<br>持卡人或发卡行未注册3D安全验证服务；</p>\n             ' +
        '       <p>· ECI=07：Visa使用。<br>ACS服务不可用或者卡片不支持3D验证。</p>\n                 </div>',
      uploadProgress: '上传进度',
      uploadLogisticsNo: '上传物流单号',
      uploadLogisticsNoTemplate: '上传物流单号',
      uploadDetails: '上传详情',
      isUploadLogistics: '是否上传物流',
      logisticsNo: '物流单号',
      logisticsProvider: '物流商',
      batchQuery: '批量查询',
      batchQueryTemplate: '批量查询',
      batchRefund: '批量退款',
      batchRefundTemplate: '批量退款',
      paymentStatus: '用户支付状态',
      refundAmountInt: '当退款币种为JPY时，退款金额必须是整数',
      download: '下载交易明细',
      dividendStatus: '分账状态',
      dividendDetailsNo: '分账明细单号',
      dividendTxnSerialNo: '分账明细交易流水号',
      dividendReceivingAccount: '分账接收账号',
      describes: '描述',
      notifyUrl: '通知地址',
      refundDetail: '退款详情',
      refundInfo: '退款信息',
      refundArn: '退款ARN',
      originTxnId: '源交易流水号',
      customerEmail: '用户邮箱',
      transactionURL: '交易网址',
      paymentSuccessTime: '支付成功时间',
      refundProcessTime: '退款处理时间',
      refundRespCode: '退款响应码',
      refundRespMsg: '退款响应信息',
      advise: '处理建议',
      refundReceipt: '退款凭证',
      refundStatus: '退款状态',
      txnProcessTime: '交易处理时间',
      timeline: '时间线',
      paymentDetails: '支付信息',
      threeDS: '3D认证',
      riskDetails: '风控信息',
      merchantDetails: '商户信息',
      redirectedCard3DS: '已跳转（卡3DS）',
      redirectedLocal: '已跳转（本地支付）',
      paymentRespCode: '支付响应码',
      paymentRespMsg: '支付响应信息',
      refundArnTips: '<p style="color:#9EA9C1;margin-bottom:8px">退款ARN</p>收单行参考编号（ARN）是分配给信用卡交易的唯一编号，用于追踪交易在支付流程中的进程。如果退款疑似丢失，银行可以通过 ARN 帮助用户追踪交易。ARN 仅适用于支持的卡网络，如果不支持，将被标记为不可用。',
      refundSuccessDesc: '退款成功（{desc1} {desc2}）',
      paymentFailDesc: '支付失败（{desc}）',
      respCodeList: '错误码列表',
      clickNumViewDetails: '你可点击单号查看详情',
      retryTransaction: '重试交易',
      expandAll: '全部展开',
      channelRequestId: '交易请求编号',
      channelRequestIdTooltip: '渠道请求 ID 是支付系统生成的唯一编号，用于标识和追踪某次交易请求在支付渠道中的状态。',
      // 渠道响应ID
      channelResponseId: '渠道响应ID',
      channelResponseIdTooltip: '渠道响应D是银行为每个支付请求分配的唯一标识符，用于标识和追踪支付的每一个环节。',
      receivedFraudNotification: '收到欺诈通知',
    },
    settlement: {
      currency: '结算币种',
      management: '结算管理',
      batchManagement: '结算批次管理',
      time: '结算日期',
      batchNo: '结算批次号',
      batchProcessingDate: '结算跑批日期',
      txnAmount: '交易金额',
      processingAmount: '处理金额',
      refundAmount: '退款金额',
      refuseAmount: '拒付金额',
      refuseProcessingAmount: '拒付处理费',
      txnProcessingAmount: '交易处理费',
      refundProcessingAmount: '退款处理费',
      txnFeeAmount: '交易手续费',
      settlementAmount: '结算金额',
      settlementStatus: '结算状态',
      disbursementTime: '付款时间',
      detailsManagement: '结算明细管理',
      orderNo: '交易订单号',
      createdAt: '订单生成时间',
      txnTime: '交易时间',
      txnCompleteTime: '交易完成时间',
      orderAmount: '下单金额',
      handlingAmount: '处理费',
      serviceAmount: '手续费',
      recalculate: '重新计算',
      atLeastOneDetail: '至少一条结算明细',
      recalculateConfirm: '确定重新计算',
      reRunBatch: '重新跑批',
      reRunBatchConfirm: '确定重新跑批',
      deposit: '保证金',
      marginRelease: '保证金释放',
      feeStatus: '计费状态',
      accountDetails: '可用余额变动明细',
      accountTxnType: '账户交易类型',
      accountTxnTime: '账户交易时间',
      changeAmount: '变动金额',
      accountBalance: '账户余额',
      accountTotalAmount: '账户总金额',
      pendingSettledAmount: '待结算金额',
      frozenAmount: '冻结金额',
      frozenAct: '冻结账户',
      marginAmount: '保证金金额',
      availableBalance: '可用余额',
      availableBalanceAct: '可用余额账户',
      refundsRevokeConfirm: '当前正在进行撤销操作，确认后将代表该笔退款已撤销，是否确认？',
      currencyViewed: '请选择要查看的币种',
      depositReleaseAmt: '释放保证金',
      restoreDetaileddeclaration: '还原明细申报',
      uploadFile: '上传文件',
      templateDownload: '模板下载（.xlsx）',
      restoreDetaileddeclarationNumber: '流水号',
      count: '总笔数',
      successCount: '成功笔数',
      failedCount: '失败笔数',
      fileName: '文件名',
      export: '导出',
      downloadFailedFile: '下载失败文件',
      disbursementNo: '付款流水号',
      disbursementCreatedAt: '付款单创建时间',
      disbursementAt: '付款时间',
      disbursementStatus: '付款状态',
      rate: '汇率',
      disbursementCurrency: '付款币种',
      disbursementAmt: '付款金额',
      payee: '收款方',
      disbursementServiceCharge: '付款手续费',
      ortherExpenses: '其它费用',
      disbursementDescription: '付款描述',
      exportSettlementDetail: '导出结算明细',
      appId: 'APPID',
      transactionUrl: '网址',
      searchTimeTip: '请选择结算日期或交易时间',
      restoreDescription: '如果您期望资金入境，您需要提供还原申报订单。请下载“模板”，填写还原申报交易数据后上传。如果您提交的还原申报交易数据上传出现了错误，您可以修改它并再次上传它。',
      capabilities: '支持币种',
      sources: '来源',
      batch: '结算批次',
      details: '结算明细',
      frozenAmountTips: '打款过程中或风控原因冻结的金额',
      decisionManagementFee: '风控管理费',
    },
    payee: {
      bankName: '银行名称',
      identificationNumber: '证件号',
      gender: '性别',
      cardNumber: '银行账号',
      creationTime: '创建时间',
      birthday: '生日',
      namePinyin: '姓名拼音',
      effectiveDate: '生效日期',
      expireDate: '失效日期',
      nationality: '国籍',
      occupation: '职业',
      bankAddress: '开户行地址',
      readAgree: '我已阅读并同意',
      idPhoto: '证件照',
      frontPhoto: '法人身份证（正面）',
      reversePhoto: '法人身份证（反面）',
      customerAgreement: '《客户服务协议》',
      customerAgreementTitle: '浙商银行“跨境人民币收款分发”客户服务协议',
      male: '男',
      female: '女',
      illegalValidityTips: '证件有效期不正确',
      selectProvince: '请选择省',
      selectCity: '请选择市',
      bankAccount: '开户行',
      mobilePhone: '手机号',
      frontPhotoTips: '请上传法人身份证（正面）',
      reversePhotoTips: '请上传法人身份证（反面）',
      essentialInformation: '基本信息：',
      payeeAccount: '收款方账户：',
      addPayeeAccountInfo: '添加收款方信息',
      seePayeeAccountInfo: '查看收款方信息',
      customerAgreementTips: '请阅读客户服务协议',
      distributableQuota: '可分发额度',
      addPayee: '添加收款人',
      payeeFileTip: '只能上传jpg,jpeg,png文件',
      legalPerson: '企业负责人',
      selfPerson: '批发和零售行业个体户',
      liberalProfessions: '自由职业',
      longEffectiveness: '长期有效',
      canAddedAgain: '待收款方认证成功后，可再次添加',
      makeItDefault: '确定设为默认吗',
    },
    payoutInfo: {
      payoutInfo: '付款方信息',
      companyName: '企业英文名称',
      country: '注册国家',
      addressEn: '英文注册地址',
      registrationNumber: '注册号',
      registrationDate: '注册日期',
      postalCode: '邮编',
      payerName: '付款方名称',
    },
    contact: {
      contact: '收款方',
      addContact: '添加收款方',
      editContact: '编辑收款方',
      beneficiaryCategory: '账户所属',
      beneficiaryType: '主体类型',
      accountCurrency: '账户币种',
      bankCountryRegion: '收款行国家/地区',
      paymentMethod: '支付方式',
      beneficiaryName: '收款方名称',
      certificateNo: '身份证号/组织机构代码',
      beneficiaryCountry: '收款方国家',
      beneficiaryAddress: '收款方地址',
      accountName: '银行账户名',
      bankName: '银行名称',
      accountNumber: '银行账号',
      swiftCode: 'Swift/Bic 代码',
      sortCode: 'Sort Code',
      file: '材料',
      own: '自有',
      others: '他人',
      individual: '个人',
      enterprise: '企业',
      business: '公司',
      downloadMaterial: '材料下载',
      setDefault: '设置默认提现账户',
      transferMoney: '付款',
      defaultAccount: '默认提现账户',
      mobilePhone: '手机号',
      localDescription: '相对便宜的支付方式，仅支持收款银行国家的本地货币',
      swiftDescription: '通常价格更高，支持的支付范围更广',
      fileTips: '*首张自有卡片将自动作为结算（提现）卡片，此时需要上传商户合同',
      vat: 'VAT缴费',
      vatFile: 'VAT税务单据',
      saveContact: '保存收款人',
      contactId: '收款人ID',
      walletPhone: '识别码',
      payeePhone: '收款方手机号',
      pickUpBank: '取款机构',
      branchName: '分支机构',
      bankBranchName: '分支名称',
      bankBranchAddress: '地址',
      pickUpBankAddress: '取款地址',
      tfPin: '取款口令',
      nickname: '昵称',
      acType: '账户类型',
      bankCode: '银行代码',
      branchCode: '分行编号',
      routingNumber: '路由号',
      walletType: '钱包信息',
      address: '收款方详细地址',
      addressPlaceholder1: '详细地址1',
      addressPlaceholder2: '详细地址2（选填）',
      addressPlaceholder3: '详细地址3（选填）',
      zipCode: '邮政编码',
      state: '收款方省市',
      city: '收款方城市',
      birthDate: '出生日期',
      transferTo: '付款至',
      accountBank: '银行账户',
      swiftTitle: 'SWIFT',
      accountWallet: '钱包',
      accountCash: '现金支取',
      firstName: '名',
      lastName: '姓',
      companyName: '企业名称',
      jpNameTips: '当付款到日本时，只允许填写Latin，否则可能引起付款失败',
      swiftCodeInputTitle: '填入 SWIFT CODE 或银行名称搜索',
      atLeast3SwiftCodeTips: '请至少输入3位代码以便搜索结果',
      swiftCodeInputTips: '请输入SWIFT CODE或银行名称查询',
      payeeTips: '用于区分收款人，不允许重复',
      bankCodeTips: '请填写Sort Code / ABA Routing Number等银行代码',
      bankHolderNameTip: '付款到印尼公司，银行账户名须确保与银行账户注册名称一致，否则该笔付款可能失败。',
      identificationNumber: '身份证号码',
      organizationCode: '组织机构代码',
      payerNameTips: '英国、欧洲的银行转账支持显示经Onerway平台方审核后的付款方名称，作为收款方实际可查看的名称。未填写将以默认名义出账。',
      accountLabeltips: '请填写钱包对应的钱包识别码，例如钱包为PayPal，则填写PayPal对应的邮箱；钱包为Gcash，则填写Gcash对应的手机号',
    },
    account: {
      info: '账户信息',
      loginEmail: '登录邮箱',
      contactEmail: '联系邮箱',
      registrationTime: '注册时间',
      merchantNo: '商户号',
      merchantName: '商户名称',
      customEmail: '用户邮箱',
    },
    application: {
      addApp: '新增应用',
      appNameTip: '请输入应用名称',
      appTypeTip: '请选择应用类型',
      appWebsiteTip: '请输入应用网址',
      addYourApplication: '添加您的应用',
      addAppTitle: '您的应用在这里!',
      addAppDescription: '这里是您的应用列表，生效后就可以开始交易了。',
      nameAndId: '应用名称；应用ID',
      myApp: '我的应用/网址',
      newWebsiteApp: '新应用/网址',
      newWebsiteAppDes: '请根据以下信息创建网站，我们将尽快处理您提交的网站信息。 ',
      appNameErrorTips: '店铺名称请限制在64个英文字符（或者32个汉字）以内',
      appType: '网站类型',
      merchantName: '店铺名称',
      aliExpressAccount: '速卖通账号',
      aliExpressEntityName: '速卖通注册主体名称',
      aliExpressMerchantUrl: '速卖通店铺URL',
      site: '主营站点',
      applyChannelEmail: '申请店铺的邮箱',
      storeUrl: '店铺网址',
      paypalEmail: 'PayPal账户邮箱',
      paypalMerInfo: 'PayPal商家信息',
      paypalMerAccount: 'PayPal商家账号',
      paypalUserInfo: 'PayPal用户信息',
      salesCategory: '销售类目',
      expectedAnnualSales: '预计年销量',
      websiteUrl: '网站URL',
      otherMaterial: '其他资料',
      paypalScreenshot: 'PayPal截图',
      ownershipFile: '店铺归属证明文件',
      sellId: '卖家编号',
      amazonHolderNameTip: '必须与亚马逊注册主体公司名称保持一致，否则影响资金入账',
      createTime: '店铺创建时间',
      id: '店铺ID',
      websiteType: '店铺类型',
      auditStatus: '店铺审核状态',
      edit: '修改店铺资料',
    },
    refuse: {
      arn: '拒付ARN',
      status: '拒付状态',
      enterTime: '拒付录入时间',
      sourceType: '拒付来源类型',
      date: '拒付日期',
      disputeDueDate: '抗辩到期日',
      code: '拒付代码',
      reason: '拒付原因',
      revoke: '拒付撤销',
      appealMaterials: '需要的抗辩材料',
      agentStatus: '代理状态',
      appealStatus: '抗辩状态',
      appealDetails: '抗辩明细',
      appealAudit: '抗辩审核',
      appealCountdown: '响应倒计时天数',
      appealWrittenDescription: '抗辩文字说明',
      appealFile: '抗辩材料',
      appealFileOptional: '抗辩材料（选填）',
      appealFileTemplate: '抗辩模板',
      submitMaterials: '提交抗辩材料',
      submitMaterialsEndTime: '材料提交截止时间',
      refundInformation: '退款信息',
      refuseFileTip: '只能上传.pdf文件',
      refuseFileImageTip: '只接受JEPG和TIFF文件',
      refuseAppealExplainTip: '请输入抗辩文字说明',
      refuseAppealDataTip: '请上传抗辩材料',
      refuseAcceptTips: '当前正在进行接受拒付操作，是否确认？',
      details: '拒付详情',
      chargebackAlert: '拒付预警',
      secondAppealConfirm: '确认进行二次抗辩？',
      secondAppealConfirmTips: '若二次抗辩失败，将收取500美金左右的罚金，具体金额以实际收取为准',
      refuseId: '拒付流水号',
      refuseInfo: '拒付信息',
      receivedTime: '拒付新增时间',
      viewRebuttal: '查看抗辩',
      daysLeftToResponse: '响应倒计时天数',
      expired: '已过期',
      quickFilterReceived: '新增拒付',
      quickFilterRebuttal: '抗辩中',
      quickFilterAll: '所有拒付',
      quickFilterWon: '抗辩成功',
      quickFilterLoss: '抗辩失败',
      quickFilterClosed: '已关闭',
      dueDate: '拒付截止日期',
      klarnaRebutDrawer: {
        continueRebut: '继续抗辩',
        title: '提交抗辩材料',
        saveDraft: '暂存',
        nextStep: '下一步',
        prevStep: '上一步',
        submit: '提交',
        chargeInfoTitle: '拒付信息',
        chargeInfoDate: '拒付日期',
        chargeInfoDeadline: '响应截止时间',
        chargeInfoAmount: '拒付金额',
        chargeInfoReason: '拒付原因',
        chargeInfoMethod: '支付方式',
        stepOneTitle: '第一步。共两步',
        stepTwoTitle: '第二步。共两步',
        fillRebuttalTitle: '填写抗辩信息',
        fillRebuttalTitleTwo: '上传证明材料',
        fillRebuttalDesc: '尽可能多的完善抗辩资料有助于我们收集更多的证据，以此来反驳持卡人的主张。',
        fillRebuttalDescTwo: '仅支持PDF文件，内容需为英文（允许包含如中文物流详情等图片）。每个上传部分最多可上传3个文件，每个文件大小不得超过2MB。',
        productFormTitle: '产品信息',
        productFormWebsite: '购物网址',
        productFormTerms: '购物条款',
        productFormDesc: '商品名称与售前描述',
        productFormWebsitePlaceholder: '请输入有效网址',
        productFormTermsPlaceholder: '请输入退款、物流相关的条款说明或链接',
        uploadTips: '点击这里上传文件或将文件拖拽到此处',
        transaction: {
          title: '交易信息',
          transactionId: '交易流水号',
          orderId: '商户订单号',
          time: '交易时间',
          ip: 'IP',
          userAgent: 'User agent',
          tableTitle: '退款信息',
        },

        customer: {
          title: '客户信息',
          firstName: '名',
          lastName: '姓',
          email: '邮箱',
          phone: '电话',
          addressTitle: '账单地址',
        },

        address: {
          title: '账单地址',
          city: '城市',
          state: '州',
          country: '国家',
          postalCode: '邮政编码',
          line1Placeholder: '填写街道地址和门牌号',
          line2Placeholder: '（可选）补充地址信息，如楼层或单元号',
        },

        shipping: {
          title: '邮寄信息',
          goodType: '商品类型',
          trackingNumber: '物流单号',
          trackingNumberPlaceHolder: '请输入派送快递单号',
          firstName: '名',
          lastName: '姓',
          phone: '电话',
          addressTitle: '邮寄地址',
        },
        appealExplain: '抗辩回复',

        appealReply: {
          title: '抗辩回复',
          appealExplain: '抗辩回复',
          placeholder: '请输入英文',
        },

        shippingUpload: {
          title: '上传物流材料',
          physicalTips: '推荐上传签收证明和其他物流证明',
          intangibleTips: '例如 发货邮件、登录信息等',
          pickUpTips: '证明必须包括客户姓名、取货日期和时间以及产品清单；或提供至少保存9个月的取货授权书',
        },

        otherUpload: {
          title: '上传其他材料',
          fileTypePlaceholder: '选择材料类型',
          tooltips: '例如对话副本等',
        },

        leave: {
          title: '内容未保存',
          content: '退出将清空所有数据。是否保存进度后再退出？',
          confirmText: '退出',
          cancelText: '继续编辑',
        },

        downloadAll: '下载全部',
        uploadErrorMessage: '请上传文件',
        uploadErrorMessage1: '请选择文件类型',
        uploadErrorMessage2: '同一类型文件最多上传3份',

      },
    },
    dispute: {
      appealFileTime: '上传时间',
      appealFileName: '抗辩材料名',
      englishOnly: '(建议使用英文)',
      fileUploadFormatSupplement: '补充抗辩材料时，仅能新增提交材料，不能对已提交的材料进行修改或删除。',
      fileUploadFormat: '只支持PDF格式，PDF内容必须是使用英文填写（图片内容，如中文物流信息除外）。 每次最多只能上传10个文件，每个文件最大为2MB。 建议将所有抗辩材料整理到一个PDF文档中',
      discoverFileUploadFormat: '仅支持 TIFF 和 JPEG 格式，内容需为英文。您最多可一次上传 10 个文件，每个文件最大 5MB。请上传内容包含：订单信息，物流证明，支付信息，商品描述，沟通记录的图片',
      explain0: '非常见原因。',
      explainAnswer0: '请咨询客户经理或其他工作人员。',
      explain1: '持卡人参与交易，因商户无法或不愿提供商品/服务，导致持卡人或被授权人未收到购买的商品或服务。',
      explainAnswer1: '如果商品已被签收，请提供文件证明持卡人/授权人本人在约定地点和约定日期收到商品或服务。\n如果货物在途尚未送达，请提供发货证明和跟踪物流详情，并提供按时发货的证明。',
      explain2: '以下任意一种情况：\n持卡人撤销了对重复交易进行收费的许可，如订阅服务（适用欧洲地区），或者分期交易（适用所有地区）、会员费。\n持卡人账户已被注销。',
      explainAnswer2: '提供文件证明持卡人或授权人未取消服务/商品；\n提供文件证明您和收单方均未收到持卡人交易账户已关闭的通知；\n在除欧洲以外的地区，还可以提供文件证明该交易之前没有被退款。',
      explain3: '以下任意一种情况\n持卡人或授权人收到的商品/服务与交易时商品页面或其他文件上的描述不符；\n持卡人或授权人收到的商品有损坏或缺陷（不包括法国）；\n持卡人或授权人对商品或服务的质量提出异议（不包括法国）。',
      explainAnswer3: '提供文件证明商品/服务与描述一致（第三方的证明材料或描述），同时证明持卡人没有退货的意向或行为。 ',
      explain4: '持卡人或授权人声称购买的商品是假冒的。',
      explainAnswer4: '提供所购商品是正品和持卡人在交易过程中已了解商品质量的证明。',
      explain5: '持卡人声称购买的商品/服务在交易过程中得到的关于商品/服务的描述是虚假的。 （包括虚假广告和商家伪造商品/服务的质量报告）。',
      explainAnswer5: '提供关于持卡人购买的商品/服务在交易过程中的所有描述都是准确的、没有虚假陈述的证明。',
      explain6: '以下任意一种情况：\n持卡人未收到商品退款或收到无效的退款收据；\n持卡人取消或退回商品、取消服务、取消分期交易、取消预订，但商户未处理或给出了无效交易收据；\n商家在交易时未正确披露或未完全披露有限退货/取消政策，在持卡人退货退款时扣款，导致持卡人对扣款未退部分提起纠纷；\n原始信用交易未被接受，或适用法律或法规禁止的原始信用交易',
      explainAnswer6: '提供证据证明持卡人并未取消商品或没有尝试退货的行为；\n提供证据证明在交易时，合理合规的向持卡人披露了有限退货/取消政策；\n提供证据证明持卡人收到了或已知商品/服务的取消/退货政策。',
      explain7: '持卡人声称商家未对已取消的商品/服务进行退款处理。',
      explainAnswer7: '提供证据证明交易没有被取消，并且持卡人没有提出取消该交易的任何要求。',
      explain8: '持卡人对购买提出异议。 这可能出于多种原因，例如未收到商品或收到了损坏/有缺陷的商品。',
      explainAnswer8: '提供文件证明持卡人收到的商品/服务与描述一致（第三方的证明材料或描述）',
      explain9: '持卡人已付款但未收到商品/服务',
      explainAnswer9: '如果商品已被签收，请提供文件证明持卡人/授权人本人在约定地点和约定日期收到商品或服务。\n如果货物尚未送达，请提供发货证明和跟踪物流详情，并提供与客户积极沟通的证明。',
      explain10: '持卡人未收到退货/取消商品的退款。',
      explainAnswer10: '提供商品从未被退回的证明，或未接受商品取消或退款已处理的证明。',
      explain11: '以下任意一种情况：\n无卡环境中进行的交易，且持卡人未授权或未参与；\n在无卡环境中使用未发行/未支付的有效卡且未获得授权的账号完成的欺诈交易。',
      explainAnswer11: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据。',
      explain12: '以下任意一种情况：\n无卡环境中进行的交易，且持卡人未授权或未参与；\n在无卡环境中使用未发行/未支付的有效卡且未获得授权的账号完成的欺诈交易。',
      explainAnswer12: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据。',
      explain13: '持卡人没有授权任何人支付这笔交易。',
      explainAnswer13: '提供与持卡人之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      explain14: '持卡人或卡授权使用人在交易期间仍拥有并控制该卡，并且持卡人承认在给定商户位置进行了至少一次的合法交易，但否认在同一位置的商户进行了一次或额外的多次交易。',
      explainAnswer14: '提供持卡人是参与交易的买家的证明。',
      explain15: '持卡人或商户涉及欺诈调查',
      explainAnswer15: '提供持卡人是参与交易的买家的证明。',
      // explain16: '此拒付涉及使用不正确的交易代码。 （如商家收到错误的 API ）',
      // explainAnswer16: '提供来自支付处理器和网关的交易数据，以证明交易代码是正确的。',
      explain17: '持卡人因交易金额的调整或原交易被取消/撤销而对调整的有效性提出异议。',
      explainAnswer17: '提供原始交易日期和交易金额和交易金额变更的详细情况。',
      explain18: '持卡人同一个帐号多次支付单笔交易；\n持卡人通过其他方式付款。',
      explainAnswer18: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。 \n提供文件证明持卡人没有通过其他方式进行付款。',
      explain19: '支付时系统处理错误导致的重复交易',
      explainAnswer19: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。 \n提供文件证明持卡人没有通过其他方式进行付款。',
      explain20: '持卡人同意支付的金额与被收取的金额不同。',
      explainAnswer20: '提供交易扣款金额在持卡人同意的金额范围内的证明；\n提供交易金额是正常处理的证明。',
      explain21: '以下任意一种情况：\n持卡人使用两种不同的付款方式为同一笔交易付款两次；\n持卡人的账户因同一笔交易被多次被扣款。',
      explainAnswer21: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。 \n提供文件证明持卡人没有通过其他方式进行付款。',
      // explain22: '持卡人没有授权该笔交易，或该卡不再属于或不曾属于交易上的持卡人',
      // explainAnswer22: '提供授权请求中的服务代码，以及参与交易的卡不是混合卡，交易是用有效芯片完成的证明。',
      explain23: '持卡人不确认是否授权任何人支付这笔交易。',
      explainAnswer23: '提供与买家之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      explain24: '持卡人不确认是否授权任何人支付这笔交易。',
      explainAnswer24: '提供与买家之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      // explain25: '持卡人不确认是否授权任何人支付这笔交易。',
      // explainAnswer25: '提供与买家之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      explain26: '持卡人不确认是否授权任何人支付这笔交易。',
      explainAnswer26: '提供与买家之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      // explain27: '以下任意一种情况：\n需要持卡人授权但未获得授权的交易；\n不存在的主账号（PAN）的交易。',
      // explainAnswer27: '提供交易是在预授权或授权批准后的七个工作日内提交的且授权未被撤销的证明；\n提供发行人的交易账户未被永久关闭的证明。',
      explain28: '此拒付涉及使用不正确的交易代码。 （如商家收到错误的 API ）',
      explainAnswer28: '提供来自支付处理器和网关的交易数据，以证明交易代码是正确的。',
      // explain29: '发卡行拒绝核准该交易',
      // explainAnswer29: '提供与买家之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      // explain30: '交易传递出现延误',
      // explainAnswer30: '提供与买家之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      explain31: '持卡人同一个帐号多次支付单笔交易；\n持卡人通过其他方式付款。',
      explainAnswer31: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。 \n提供文件证明持卡人没有通过其他方式进行付款。',
      // explain32: '持卡人因交易金额的调整或原交易被取消/撤销而对调整的有效性提出异议。',
      // explainAnswer32: '提供原始交易日期和交易金额和交易金额变更的详细情况。',
      // explain33: '持卡人因交易金额的调整或原交易被取消/撤销而对调整的有效性提出异议。',
      // explainAnswer33: '提供原始交易日期和交易金额和交易金额变更的详细情况。',
      explain34: '以下任意一种情况：\n无卡环境中进行的交易，且持卡人未授权或未参与；\n在无卡环境中使用未发行/未支付的有效卡且未获得授权的账号完成的欺诈交易。',
      explainAnswer34: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据。        ',
      explain35: '以下任意一种情况：\n无卡环境中进行的交易，且持卡人未授权或未参与；\n在无卡环境中使用未发行/未支付的有效卡且未获得授权的账号完成的欺诈交易。',
      explainAnswer35: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据。',
      // explain36: '持卡人同一个帐号多次支付单笔交易；\n持卡人通过其他方式付款。',
      // explainAnswer36: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。 \n提供文件证明持卡人没有通过其他方式进行付款。',
      // explain37: '持卡人信息被盗用',
      // explainAnswer37: '提供持卡人是参与交易的买家的证明。',
      explain38: '此拒付涉及使用不正确的交易代码。 （如商家收到错误的 API ）',
      explainAnswer38: '提供来自支付处理器和网关的交易数据，以证明交易代码是正确的。',
      explain39: '持卡人没有授权该笔交易，或该卡不再属于或不曾属于交易上的持卡人',
      explainAnswer39: '提供授权请求中的服务代码，以及参与交易的卡不是混合卡，交易是用有效芯片完成的证明。',
      explain40: '持卡人没有授权该笔交易，或该卡不再属于或不曾属于交易上的持卡人',
      explainAnswer40: '提供授权请求中的服务代码，以及参与交易的卡不是混合卡，交易是用有效芯片完成的证明。',
      explain41: '持卡人因交易金额的调整或原交易被取消/撤销而对调整的有效性提出异议。',
      explainAnswer41: '提供原始交易日期和交易金额和交易金额变更的详细情况。',
      explain42: '持卡人参与交易，因商户无法或不愿提供商品/服务，导致持卡人或被授权人未收到购买的商品或服务。',
      explainAnswer42: '如果商品已被签收，请提供文件证明持卡人/授权人本人在约定地点和约定日期收到商品或服务。\n如果货物在途尚未送达，请提供发货证明和跟踪物流详情，并提供按时发货的证明。',
      explain43: '此拒付涉及使用不正确的交易代码。 （如商家收到错误的 API ）',
      explainAnswer43: '提供来自支付处理器和网关的交易数据，以证明交易代码是正确的。',
      explain44: '持卡人未收到退货/取消商品的退款',
      explainAnswer44: '提供商品从未被退回的证明，或未接受商品取消或退款已处理的证明',
      explain45: '持卡人同一个帐号多次支付单笔交易；\n持卡人通过其他方式付款。',
      explainAnswer45: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。\n提供文件证明持卡人没有通过其他方式进行付款。',
      explain46: '以下任意一种情况：\n持卡人撤销了对重复交易进行收费的许可，如订阅服务（适用欧洲地区），或者分期交易（适用所有地区）、会员费。\n持卡人账户已被注销。',
      explainAnswer46: '提供文件证明持卡人或授权人未取消服务/商品；\n提供文件证明您和收单方均未收到持卡人交易账户已关闭的通知；\n在除欧洲以外的地区，还可以提供文件证明该交易之前没有被退款。',
      explain47: '持卡人没有授权任何人支付这笔交易。',
      explainAnswer47: '提供与持卡人之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      explain48: '以下任意一种情况：\n无卡环境中进行的交易，且持卡人未授权或未参与；\n在无卡环境中使用未发行/未支付的有效卡且未获得授权的账号完成的欺诈交易。',
      explainAnswer48: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据。 ',
      explain49: '持卡人参与交易，因商户无法或不愿提供商品/服务，导致持卡人或被授权人未收到购买的商品或服务。',
      explainAnswer49: '如果商品已被签收，请提供文件证明持卡人/授权人本人在约定地点和约定日期收到商品或服务。\n如果货物在途尚未送达，请提供发货证明和跟踪物流详情，并提供按时发货的证明。',
      explain50: '以下任意一种情况\n持卡人或授权人收到的商品/服务与交易时商品页面或其他文件上的描述不符；\n持卡人或授权人收到的商品有损坏或缺陷（不包括法国）；\n持卡人或授权人对商品或服务的质量提出异议（不包括法国）。',
      explainAnswer50: '提供文件证明商品/服务与描述一致（第三方的证明材料或描述），同时证明持卡人没有退货的意向或行为。',
      explain51: '持卡人未收到退货/取消商品的退款。',
      explainAnswer51: '提供商品从未被退回的证明，或未接受商品取消或退款已处理的证明。',
      explain52: '以下任意一种情况：\n需要持卡人授权但未获得授权的交易；\n不存在的主账号（PAN）的交易。',
      explainAnswer52: '提供交易是在预授权或授权批准后的七个工作日内提交的且授权未被撤销的证明；\n提供发行人的交易账户未被永久关闭的证明。',
      explain53: '以下任意一种情况：\n无卡环境中进行的交易，且持卡人未授权或未参与；\n在无卡环境中使用未发行/未支付的有效卡且未获得授权的账号完成的欺诈交易。',
      explainAnswer53: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据',
      explain54: '以下任意一种情况：\n需要持卡人授权但未获得授权的交易；\n不存在的主账号（PAN）的交易。',
      explainAnswer54: '提供交易是在预授权或授权批准后的七个工作日内提交的且授权未被撤销的证明；\n提供发行人的交易账户未被永久关闭的证明。',
      explain55: '持卡人没有收到商品或服务。',
      explainAnswer55: '如果商品已被签收，请提供文件证明持卡人/授权人本人在约定地点和约定日期收到商品或服务。\n如果货物在途尚未送达，请提供发货证明和跟踪物流详情，并提供按时发货的证明。',
      explain56: '持卡人收到的商品或服务与描述不符。',
      explainAnswer56: '提供文件证明商品/服务与描述一致（第三方的证明材料或描述），同时证明持卡人没有退货的意向或行为。',
      explain57: '持卡人未授权购买商品或服务。由于串通、欺诈监控程序阈值或任何其他原因，责任转移到商家。',
      explainAnswer57: '提供是持卡人本人的印章/签名/PIN的证明\n提供发卡行使用持卡人身份验证，响应了身份验证请求的证明；\n提供交易被正确授权的证据。',
      explain58: '持卡人购买已取消或退货，但退款尚未处理。',
      explainAnswer58: '提供商品从未被退回的证明，或未接受商品取消或退款已处理的证明。',
      explain59: '付款处理了两次',
      explainAnswer59: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。\n提供文件证明持卡人没有通过其他方式进行付款。',
      explain60: '付款金额与约定金额不同。',
      explainAnswer60: '提供原始交易日期和交易金额和交易金额变更的详细情况。',
      explain61: '持卡人通过其他方式支付了交易费用。',
      explainAnswer61: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。\n提供文件证明持卡人没有通过其他方式进行付款。',
      explain62: '持卡人取消商品/服务',
      explainAnswer62: '提供证据证明交易没有被取消，并且持卡人没有提出取消该交易的任何要求。',
      explain63: '客户提供的 IBAN 或 BIC 代码不正确。',
      explainAnswer63: '请联系您的客户确认 IBAN 是否正确。',
      explain64: '账户已关闭。客户可能使用了旧帐号，或在设立委托后关闭了帐户。',
      explainAnswer64: '联系您的客户，获取新账户的详细信息。',
      explain65: '该账户已被银行或客户冻结，无法进行直接借记。可能是默认冻结，在这种情况下，债务人可以解除冻结。',
      explainAnswer65: '联系买家请求更换支付账户。',
      explain66: '此类账户无法实施 SEPA 直接借记。例如：储蓄账户。',
      explainAnswer66: '请联系买家以获取有关要使用的帐户的信息。',
      explain67: '银行操作代码无效。',
      explainAnswer67: '联系支付网关。',
      explain68: '由于资金不足，付款人的银行无法支付直接借记。',
      explainAnswer68: '联系买方向账户充钱，并重新提交付款。',
      explain69: '以下任意一种情况：\n持卡人使用两种不同的付款方式为同一笔交易付款两次；\n持卡人的账户因同一笔交易被多次被扣款。',
      explainAnswer69: '提供有签名或印章的交易收据或其他记录，证明处理的是不同的交易。\n提供文件证明持卡人没有通过其他方式进行付款。',
      explain70: '您提交的客户姓名与所提供账户的实际账户持有人姓名不符。',
      explainAnswer70: '请联系您的客户了解详情。',
      explain71: '终端客户无法识别发起信息的一方。',
      explainAnswer71: '更正债权人身份标识符并重新提交。',
      explain72: '债务人银行的 BIC 代码未知或与 IBAN 不匹配。',
      explainAnswer72: '如果 IBAN 与瑞士的一个账户相对应，但债务人的地址尚未传送，则可能出现这种情况。',
      explain73: '无效的文件格式。',
      explainAnswer73: '请联系您的支付网关。',
      explain74: '无效代码。',
      explainAnswer74: '请联系您的支付网关。',
      explain75: '持卡人没有授权任何人支付这笔交易。',
      explainAnswer75: '提供与持卡人之间的书面信函副本（如信件、电子邮件或传真），证明持卡人或授权用户参与了交易。',
      explain76: '授权数据缺失或不正确。',
      explainAnswer76: '请联系您的支付网关。',
      explain77: '您的客户已就授权交易申请退款。',
      explainAnswer77: '请联系买家。',
      explain78: '您试图为已故个人的账户设立委托。极为罕见。',
      explainAnswer78: '终止与已故客户的协议。',
      explain79: '买方拒绝直接付款。',
      explainAnswer79: '请联系买家。',
      explain80: '最常见的错误代码之一。通常用于银行出于数据保护原因选择不发出更具体的原因代码的情况。',
      explainAnswer80: '请联系买家。',
      explain81: '客户提供的 BIC 代码不正确。',
      explainAnswer81: '请联系您的客户以获取正确的 BIC。',
      explain82: '缺少付款人的账户信息。',
      explainAnswer82: '请联系您的支付网关。',
      explain83: '缺少付款人姓名或详细地址。',
      explainAnswer83: '请联系您的支付网关。',
      explain84: '缺少您的姓名或详细地址。您可以在提交之前自行进行这些检查。',
      explainAnswer84: '如果是由于信息缺失，则修改收款并重新提交。如果是监管原因，请联系客户银行。',
      explain85: '监管原因。',
      explainAnswer85: '联系您的银行，并要求他们联系买家的银行以了解拒绝原因。',
      explain86: '请求与买方为其账户设置的特定指令相冲突。\n例如：债务人被列入黑名单',
      explainAnswer86: '请联系买家。',
      explain87: '时间限制已过。',
      explainAnswer87: '请联系您的支付网关。',

      disputeInfo: '争议信息',
      disputeReason: '争议原因',
      disputeDetail: '争议详情',
      titleTip: '本页面列出了有拒付风险的交易。<br>您可以自行审核并完成退款操作',
    },
    subscription: {
      contractNo: '订阅合同号',
      contractId: '订阅合同号',
      collectionMethod: '扣款方式',
      startTime: '开始时间',
      createDate: '开始时间',
      expireDate: '到期日期',
      frequency: '扣款频率',
      baseInfo: '订阅基本信息',
      productInfo: '订阅产品信息',
      status: '订阅状态',
      billingCycle: '计费周期',
      cardInfo: '卡信息',
      cardNo: '卡号',
      defaultCardNo: '默认支付卡',
      customerInfo: '客户信息',
      customerName: '客户姓名',
      txnHistory: '历史订阅交易记录',
      details: '订阅详情',
      cancelConfirm: '确认取消此订阅',
      statusData: {
        0: '未生效',
        1: '生效',
        2: '关闭',
        3: '已取消',
      },
      paymentMethodData: {
        1: '自动扣款',
        2: '手动扣款',
      },
      frequencyData: {
        Y: '{year}年',
        W: '{week}周',
        // W: '{week}周',
        D: '{day}天',
        H: '{hour}小时',
        M: '{minute}分',
      },
      _frequencyData: {
        Y: '{value}年',
        W: '{value}周',
        M: '{value}月',
        D: '{value}天',
        H: '{value}小时',
      },
      remindEmailTitle: '订阅提醒邮件',
      remindEmailDesc: '开启后将即刻开始对用户发送订阅创建成功、续订扣款、扣款成功、扣款失败、扣款连续失败、订阅停止、订阅变更相关邮件。',
      changeInfoText: '变更后该订阅扣款时间为变更当日，并从1期开始扣款。后续扣款将根据新订阅计划进行。',
      quickAccess: '快速访问',
      keyInfo: '关键信息',
      subscriptionInfo: '订阅信息',
      customerInformation: '顾客信息',
      deductionHistory: '扣款历史',
      assessedAmount: '分摊金额',
      billingCountsTips: '<div>显示现扣款期数和总期数</div><div>期数为--代表永久持续扣款</div><div>期数为1-100任意值代表以该数值为期数限制进行扣款</div>',
      collectionTime: '扣款时间',
      hasSubscription: '订阅的',
      cancelSubsBtn: '取消订阅',
      subsInfo: '订阅信息',
      editBtn: '编辑',
      nextCollectionTime: '下次扣款时间',
      nextCollectionAmount: '下次扣款金额',
      timeliness: '时效',
      transactionUrl: '交易网址',
      trailEndDate: '试用结束于',
      productName: '产品名称',
      startDate: '开始日期',
      endDate: '到期日期',
      billingCounts: '扣款期数',
      billingFrequency: '扣款频率',
      productPrice: '产品单价',
      productQuantity: '产品数量',
      billingAmount: '扣款金额',
      customerId: '客户ID',
      email: '用户邮箱',
      paymentMethods: '支付方式',
      editSubsInfo: '编辑订阅信息',
      cancelSubsDialogTitle: '取消订阅',
      exportBtn: '导出',
      cancelSubsBtn1: '当期结束后取消',
      cancelSubsBtn2: '指定日期取消',
      cancelSubsBtn3: '立即取消',
      productCount: '产品数量',
      _cycleCount: '扣款期数',
      cycleCount: '总扣款期数',
      orderAmount: '扣款金额',
      proration: '分摊金额',
      pickDateTip: '请选择指定日期',
      hugeMoneyTip: '超出金额限制',
      expireDateErrorTips: '不能晚于当前期数计算出来的结束日期，如果晚于该日期报错“请根据扣款频率和期数填写正确的过期日期”',
      prorationTip: '在订阅升级或降级时，分摊金额表示您希望立即向消费者扣除或退还的金额：',
      prorationTip1: '0：不向消费者扣出/退回款项',
      prorationTip2: '正数：立即向消费者扣除对应金额',
      prorationTip3: '负数：立即向消费者退回对应金额（暂不支持）',
      statusActiveTip: '订阅变更计划已确认，具体内容查看订阅详情。',
      statusCancelTip: '订阅将在指定日期取消。',
      statusUpdatingTip: '订阅将在指定日期更新。',
    },
    wallet: {
      time: '时间',
      subAccountType: '子账户类型',
      openingAmount: '期初金额',
      closingAmount: '期末金额',
      movingAmount: '动账金额',
      recharge: '充值',
      payout: '付款',
      rechargeTitle: '为{currency}账户进行充值',
      rechargeSubTitle: '请根据以下信息进行转账来为您的{currency}钱包充值。',
      rechargeCurrencyInfo: '{currency}充值信息',
      rechargeWaring: '请确保准确使用以下账户名，否则您的充值可能会被退还。',
      rechargeForAccount: '向账户充值',
      selectRechargeCurrency: '请选择充值币种账户',
      rechargeBankInfo: '银行账户信息：',
      rechargeTips1: '1、完成线下打款即可完成当前账户币种的充值。您的资金将会1~2个工作日处理完毕，进入账户余额。',
      rechargeTips2: '2、请注意，银行打款时，请确保填写正确的“交易附言”。',
      openRechargeVa: '开通充值账户',
      actAmountTips: '账户总金额=可用余额+待结算金额+冻结金额+保证金金额',
      rechargeTips: '{currency}充值，请与您的客户经理联系',
    },
    download: {
      modalTitle: '当前下载内容',
      fileName: '文件名称',
      source: '来源',
      gotoDownloadCenter: '进入下载中心',
      downloadCenter: '下载中心',
      gotoUploadDetails: '进入上传详情',
      taskManager: '任务管理',
    },
    notice: {
      message: '消息',
      noticeCenter: '消息中心',
      noticeDetail: '消息详情',
      notice: '公告',
    },
    searchCommon: {
      all: '全部',
      search: '查询',
      startTime: '开始时间',
      endTime: '结束时间',
      startTimeTip: '请选择{time}->开始时间',
      endTimeTip: '请选择{time}->结束时间',
      stowOptions: '收起查询条件',
      moreOptions: '更多查询',
    },
    tableTitleCommon: {
      saveConfiguration: '保存设置',
      defaultConfiguration: '使用默认设置',
      visibleColumns: '可见列',
      selectOneTitle: '至少选择三个标题',
      previous: '上一页',
      next: '下一页',
    },
    tableCommon: {
      operator: '操作人',
      operation: '操作',
      operationTime: '操作时间',
      LatestOperationTime: '最近操作时间',
      appeal: '抗辩',
      see: '查看',
      acceptDishonor: '接受拒付',
      website: '交易网址',
      cardType: '支付方式',
      subCardType: '钱包',
      remark: '备注',
      txnSerialNumber: '交易流水号',
      merchantOrderNumber: '商户订单号',
      merchantOriginalOrderNumber: '原始订单号',
      // 卡类型
      cardCategoryName: '卡类型',
      // 卡标识
      cardIdentifier: '卡标识',
      originalTxnSerialNumber: '源交易流水号',
      originalTxnSerialNumber_new: '源交易流水号',
      subProductType: '支付模式',
      productType: '支付类型',
      bankCardNo: '卡号',
      cardNumber: '卡号',
      appId: '应用ID',
      appName: '应用名称',
      appType: '应用类型',
      appWebsite: '应用网址',
      arn: 'ARN',
      email: '邮箱',
      refundState: '退款状态',
      cardBinCountry: '发卡国家',
      products: '商品信息',
      userAgent: 'User agent',
      auditStatus: '审核状态',
      onlineRefundStatus: '退款状态',
      refundType: '退款类型',
      refundTime: '退款申请时间',
      refundDate: '退款时间',
      refundAuditTime: '退款审核时间',
      originTxnAmount: '源交易金额',
      originTxnTime: '源交易时间',
      txnTime: '交易时间',
      txnType: '交易类型',
      txnStatus: '交易状态',
      orderAmount: '订单金额',
      // 结算币种金额
      settlementCurrencyAmount: '结算币种金额 ',
      txnAmount: '交易金额',
      refund: '退款',
      refundAmount: '退款金额',
      refundedAmount: '已退款金额',
      refundSucceedAmount: '已退款金额',
      refundReviewNumber: '退款审核流水号',
      eci: 'ECI',
      requestId: '商户唯一请求号',
      ip: 'IP',
      require3d: '是否请求3DS',
      currency: '币种',
      transaction_currency: '订单币种',
      serialNumber: '序号',
      refundsRevoke: '撤销',
      updateTime: '更新时间',
      details: '详情',
      status: '状态',
      edit: '编辑',
      delete: '删除',
      cancel: '取消',
      notFoundInfo: '未找到信息',
      searcnEmpty: '该查询无任何信息',
      schemeAmt: 'Scheme Fee',
      markupAmt: 'Markup',
      interchangeAmt: 'Interchange Fee',
      taxes: '税费',
      default: '默认',
      makeDefault: '设为默认',
      platformFee: '平台费',
      platformType: '平台类型',
      bankAddress: '银行地址',
      bankName: '银行名称',
      creationTime: '创建时间',
      refundSerialNumber: '退款流水号',
      accountNotOpened: '账户未开通',
      otherReason: '其他说明',
      supplementary: '补充描述',
      auditOpinion: '审核意见',
      auditTime: '审核时间',
      audit: '审核',
      firstName: '名',
      lastName: '姓',
      isCompleted: '是否完成',
      selectDate: '选择日期',
      downloadResultFile: '下载结果文件',
      successfulAmountDay: '当日成功总金额',
      // 当日成功订单金额
      daily_successful_transaction_amount: '当日成功订单金额',
      // 当日结算币种金额
      daily_settlement_currency_amount: '当日结算币种金额',
      successfulCountDay: '当日成功交易总笔数',
      successfulRateDay: '当日交易成功率',
      createDate: '创建日期',
      successfulCount: '成功总笔数',
      successfulAmount: '成功总金额',
      refuseCount: '拒付总笔数',
      refuseAmount: '拒付总金额',
      refuseRate: '拒付率',
      explanation: '说明',
      card: '卡支付',
      lpms: '本地支付',
      queryHistory: '是否查询历史',
      lastUpdatedTime: '最近更新时间',
      atSelectLeastOne: '至少选择一项',
      paymentType: '支付方式',
      amount: '金额',
      fraudAdministrationFee: '欺诈管理费',
      disputePresence: '拒付状态',
      notificationOfFraud: '欺诈通知',
    },
    report: {
      refuseRateDetails: '拒付率报表详情',
      transactionReportDetails: '交易报表详情',
      successCurrencyTooltip: '全部：将不同币种的订单统一实时换算为 USD，以展示整体成功率数据。仅供参考，不用于资金结算或对账。',
      refuseCurrencyTooltip: '全部：将不同币种的订单统一实时换算为 USD，以展示整体成功率数据。仅供参考，不用于资金结算或对账。',
    },
    status: {
      yes: '是',
      no: '否',
      activation: '开通',
      inactivated: '未开通',
      noRefund: '未退款',
      allRefund: '全额退款',
      partRefund: '部分退款',
      unaudited: '待审核',
      auditSuccess: '审核通过',
      auditFail: '审核不通过',
      auditSuccessAndRefund: '审核通过并退款',
      onlineRefunds: '退款中',
      onlineRefundsRequest: '已请求退款',
      onlineRefundsSuccess: '退款成功',
      onlineRefundsFail: '退款失败',
      onlineRefundsPassed: '退款审核通过',
      onlineRefundsRejected: '退款审核未通过',
      onlineRefundsCancel: '退款撤销',
      cannotOnlineRefunds: '无法在线退款',
      cancel: '取消',
      inForce: '已生效',
      notForce: '未生效',
      refuse: '拒付',
      acceptedSuccess: '受理成功',
      noReviewRequired: '无需审核',
      parsingPending: '待解析',
      parsing: '解析中',
      parsingSucceeded: '解析成功',
      parsingFail: '解析有误',
      parseingCancel: '取消解析',
      succeed: '成功',
      succeedPartial: '部分成功',
      fail: '失败',
      processing: '处理中',
      pending: '待处理',
      undone: '未完成',
      done: '已完成',
      existAuditSuccess: '存在已审核',
      existUnAudit: '存在未审核',
      uploaded: '已上传',
      notUploaded: '未上传',
      paid: '已支付',
      unpaid: '未支付',
      retry: '重试',
      // 保存成功
      saveSuccess: '保存成功',
    },
    collection: {
      transactionRejectedTipTitle: '交易已被驳回',
      transactionPendingTipTitle: '交易挂起中',
      transactionPendingTipReason: '交易挂起中，请联系客户经理提交相关交易资料',
      type: '类型',
      accountNumber: '账号',
      accountType: '账号类型',
      payerAccountName: '付款人名称',
      payerAccountNumber: '付款账号',
      settlementTime: '结算时间',
      virtualAccountNumber: '收款账号',
      virtualAccountName: '收款人名称',
      virtualAccount: '收款账号',
      createVirtualAccount: '申请收款账号',
      editVirtualAccount: '修改收款账号',
      createVirtualAccount1: '申请全球账户',
      editVirtualAccount1: '修改全球账户',
      emptyTopTitle: '通过 ONERWAY 进入新的海外市场',
      emptyTopDesc01: '开设一个全球资金收集账户，支持美元、欧元、英镑、日元等多种国际货币。',
      emptyTopDesc02: '通过 ONERWAY 探索新市场并发展您的跨境业务',
      emptyContentTitle01: '轻松开户',
      emptyContentDesc01: '在 ONERWAY 网站实现2小时内快速开户',
      emptyContentTitle02: '快速提现',
      emptyContentDesc02: '我们帮助商家在市场上收款，并以最快T+0的速度提取现金。',
      emptyContentTitle03: '更好的汇率',
      emptyContentDesc03: '从实时汇率中受益，避免汇率波动，产生资金损失',
      emptyContentTitle04: '没有换汇限制',
      emptyContentDesc04: '没有个人外汇额度限制',
      vaFormTitleTips: '请填写您的收款账号信息',
      createVaSuccessTips: '收款账号创建成功',
      selectCountry: '银行账户所在国家',
      accountFunction: '账户功能',
      accountInfo: '账户信息',
      accountHolderName: '账户持有人名称',
      companyAddress: '公司地址',
      accountCurrency: '申请币种',
      bizType: '业务类型',
      bankLocation: '银行所在地',
      bankCountry: '银行国家',
      accountLabel: '识别码',
      note: '备注',
      iban: 'IBAN',
      swift: 'SWIFT',
      vaAccountDetails: 'VA 账号详情',
      vaTransDetails: 'VA 交易详情',
      acType: '账户类型',
      name: '股东姓名（股份超过25%）',
      address: '地址',
      street: '门牌号+楼号+街道号',
      city: '所在区+所在城市+所在省',
      country: '所在国家',
      entityType: '主体类型',
      errorTitle: '当前审核未通过，请修改申请信息，展开查看详细信息',
      bankName: '银行账户名称',
    },
    upload: {
      tip: '您可以拖拽更多文件到这里上传 <br>- 或者 -',
      limitTip: '您上传的文件太多了',
      zipOrImgtip: '支持格式zip,jpeg,jpg,png,pdf <br>-最多50M-',
      supportFileTip: '支持格式{type} <br>-最多50M-',
      supportFileAndSizeTip: '支持格式{type}，-最多{size}-',
    },
    transfer: {
      availableLimit: 'Available limit',
      uploadDate: '上传日期',
      uploadNumber: '上传流水号',
      quota: 'Quota',
      transferId: '付款流水号',
      beneficiary: '收款方',
      sendAmount: '支付金额',
      receivedAmount: '付款金额',
      completionTime: '完成时间',
      receiptDownload: '导出',
      transferMoney: '去付款',
      transferMoneyAcq: '结算出款',
      addTransferMoneyDescription: '只需点击几下，您就可以从我们的网站在线转账，无论是通过本地转账还是swift转账。',
      addTransferMoneyDescriptionAcq: '按照合同约定，您的收单业务资金将定期自动划转至预留的提现账户。',
      transferCurrency: '扣款币种',
      transferAmount: '扣款金额',
      transferFee: '手续费',
      currencyReceived: '付款币种',
      amountReceived: '预计到账',
      amountReceived1: '预计到账金额',
      payoutPostscri: '交易附言',
      referenceTips: '附言字段可能因收款银行原因，不会展示给收款方，也可能会因长度原因截断展示。',
      payPurpose: '付款用途',
      payDoc: '付款证明文件',
      contactNickname: '收款方',
      recipient: '收款方',
      contactName: '收款方',
      youSend: '您支付',
      beneficiaryGets: '预计收款方收到',
      transactionPurpose: '交易用途',
      certificate: '证明材料',
      payeeInformation: '收款方信息',
      payoutFee: '手续费',
      recipientGets: '预计收款方收到',
      contact: '收款方',
      cardHolder: '持卡人',
      swiftCode: 'SWIFT code',
      email: '邮箱验证',
      verfiyCode: '获取验证码',
      who: '你想给谁付款?',
      youContacts: '你的收款方',
      newContacts: '新建收款方',
      addContact: '添加一个收款方',
      transactionNumber: '流水号',
      payTime: '付款时间',
      payStatus: '付款状态',
      serviceFee: '手续费金额',
      otherFee: '其它金额',
      auditRemark: '付款描述',
      verfiyCodeTip: '验证码已发送至您邮箱，请注意查收',
      payer: '付款方',
      insufficientBalance: '可用余额不足',
      moreThanFee: '付款金额需大于手续费金额',
      transferToAct: '向 {payee} 付款',
      details: '付款详情',
      amount: '金额',
      frozenAmount: '风控冻结金额',
      rate: '汇率',
      payoutInfo: '付款信息',
      uploadRestoreDetails: '上传还原明细',
      limitMinAmount: '交易金额低于允许的最小金额，最小金额10.00',
      batchTransferMoney: '批量付款',
      batchTransferModalTitle: '上传批量付款文件',
      batchTransferResultTitle: '本次批量付款文件汇总',
      downloadReport: '下载报表',
      downloadCurReport: '下载当前报表',
      batchFileError: '批量付款文件有错误，请下载报表查看详情',
      batchTransferCount: '付款总笔数',
      b1atchTransferTotalAmount: '付款总金额',
      missingError: '当前{currency}账户可用余额为{availBalance}，预扣除总金额{preDeductionAmount}，缺少{shortageAmount}',
      batchTransferError: '无法完成付款，请充值或者修改批量付款文件后重试',
      batchTransferTemplate: '批量付款模板',
      needCode: '验证码错误，请重新获取验证码后重试。',
      fileBatchNo: '文件批次号',
      payoutVoucherBatch: '批量下载付款凭证',
      payoutVoucher: '付款凭证下载',
      transferAmountTips: '根据付款币种、金额的不同，到账时间可能会有差异。',
      ownContacts: '我的卡',
      otherContacts: '其他人',
      designatedPayer: '指定付款方',
      willEchangeAmount: '将换汇金额',
      validWithin: '<span style="color:#0094C6;">{time}</span> 内有效',
      saveContactInfo: '保存/更新账户信息',
      payoutPurpose: '付款用途',
      paymentMethod: '付款方式',
      fundsSource: '资金来源',
      howToPayoutMethod: '您希望收款方如何收到这笔款？',
      bankTransfer: '银行转账',
      eWallet: '钱包转账',
      cashPickup: '现金支取',
      noTransferMethodTips: '当前付款区域或付款方式暂时不可用，请更换后重试。',
      currencyAmountTips: '{currency} 只允许填写整数，请删除小数位。',
      noTransferFieldsTips: '当前付款暂不支持，请与我们联系',
      validationInpro: '正在校验',
      validatedCount: '共',
      validatedNum: '笔付款交易，正在校验中',
      validatedS: '校验成功 ',
      validatedF: '失败',
      confirmWord: '有文件正在校验中，是否确认取消',
      taskErr: '您上传的文件有错误，请与您的客户经理联系获取支持。',
      feeBearing: '由您来支付中间行和代理行的费用，付款金额预计将全额送达收款方',
      feeBearingTips: '如果中间行、代理行或收款方银行不遵循指示，并在交易汇出后从收款方收到的金额中收取额外费用，则会发生无法全额到账的例外情况。',
      feeWarning: '此金额未扣除中间行以及代理行费用。',
      feeBearingTitle: '费用收取方式',
      failReason: '失败原因 ',
    },
    exchange: {
      sameCurrency: '卖出币种和买入币种不能相同',
      exchangeMoney: '换汇',
      addExchangeMoneyDescription: '您可以使用钱包中的可用余额进行兑换，兑换后的货币将存储在相应的币种钱包中。',
      exchangeId: '换汇流水号',
      currencyExchange: '币种对',
      rate: '汇率',
      sell: '卖出',
      originCurrency: '发起币种',
      targetCurrency: '目标币种',
      buy: '买入',
      deliveryDate: '交割日',
      continue: '继续',
      amount: '金额',
      review: '确认',
      youSell: '卖出',
      youBuy: '买入',
      referenceRate: '参考汇率',
      payoutInfo: '换汇信息确认',
      guaranteedRate: '汇率',
      refresh: '刷新',
      holidayTip: '当前时间/币种不支持交易，',
      seeDetails: '详情查看',
      exchangeTips1: 'T0交易时间，USD、HKD互相兑换是截止到16点，SGD相关兑换是11点，其他币种兑换截止到15点',
    },
    risk: {
      blacklist: '黑名单',
      addBlacklist: '新建黑名单',
      addBlacklistdialog: {
        addTitle: '新建黑名单',
        editTitle: '编辑黑名单',
        blacklistName: '黑名单名称',
        attribute: '属性',
        type: '类型',
        dataCount: '条目数',
        creator: '创建者',
        addBy: '添加者',
        lastModifiedDate: '上次修改日期',
        // All payment transacitons will be affected.
        allDesc: '所有支付交易都将受到影响。',
        // Only card payment transactions will be affected.
        cardDesc: '仅卡支付类交易会受到影响。',
        // Only local payment transactions will be affected.
        lpmsDesc: '仅本地支付类交易会受到影响。',
        applyTo: '应用于',
        applyToTips: '请选择此黑名单所适用的支付类型。',
        blacklistType: '黑名单类型',
        // You need to complete the following steps:
        // 1. Download the template;
        // 2. Fill in according to the example;
        // 3. Click or drag and drop to upload the file
        batchRiskTemplateTips: [
          '您需要完成以下步骤：',
          '1. 下载模板文件；',
          '2. 按照模板文件格式填写数据；',
          '3. 点击或拖拽上传文件。',
        ],
      },
      editBlacklist: '编辑黑名单',
      addBlacklistTips: [
        '通过筛选特定数据（如电子邮件地址、IP 地址、银行卡号及电话号码等），可有效阻止高风险交易的发生。',
        '合理配置的黑名单，最高可将欺诈率降低 50%。',
      ],
      name: '名称',
      attribute: '属性',
      type: '类型',
      dataCount: '条目数',
      creator: '创建者',
      addBy: '添加者',
      lastModifiedDate: '上次修改日期',
      value: '值',
      createDate: '添加日期',
      listAttribute: '列表属性',
      listType: '列表类型',
      // Hit Count (30day)
      hitCount30Day: '命中次数',
      // Hit Rate (30day)
      hitRate30Days: '命中率 (30天)',
      // Hit Rate(30day)
      hitRate30Day: '命中率',
      listName: '列表名称',
      confirmTip: '是否{operate}该规则?',
      single: '单个',
      multi: '多个',
      uploadTip: '以xlsx文件格式上传项目列表。文件最大5M',
      // card: '卡号',
      phone: '电话号码',
      ip: 'IP地址',
      email: '邮箱(适用于邮寄邮箱和账单邮箱)',
      emailDomain: '邮箱域名',
      batchRiskTemplate: '批量名单导入',
      effectiveDate: '有效期',
      batchFileError: '名单导入文件有错误，请下载报表查看详情',
      scope: '影响范围',
      active: '激活',
      disabled: '未激活',
      // 卡号明文
      cardPlaintext: '卡号明文',
      cardInputPlaceholder: '请输入卡号',
      transactionIdPlaceholder: '请输入交易流水号',
      all: '全部交易',
      // card number
      card: '卡支付交易',
      lpms: '本地支付交易',
      // 手工输入
      manualInput: '手工输入',
      // 上传CVS
      uploadCsv: '上传CSV',
      // 过期日期
      expireDate: '有效期至',
      // 过期日期提示文案
      expireDateTips: '条目将在该日期后过期。',
      // 通过交易流水号检索
      searchByTransactionId: '通过交易流水号检索',
      status: {
        allStatus: '全部',
        // 激活
        active: '激活',
        // 未激活
        inactive: '未激活',
        // 即将过期
        expiringSoon: '即将过期',
      },
      // 条目数据
      itemsData: '条目数据',
      //  添加条目数据页面
      itemsDataTips: '添加条目数据页面',
      addBlackListItem: {
        // Add Items to Blacklist
        addItemsToBlacklist: '添加条目数据',
        // 添加条目数据
        addItems: '添加',
        // Enter data (one per line)
        itemsDataPlaceholder: {
          enterDataOnePerLine: '请输入数据（每行一个）',
          // Example:
          example: '示例：',
          // @spam.com
          example2: '@spam.com',
          // @blacklist.com
          example3: '@blacklist.com',
        },
        // If the Expire Date is not set, the value is valid for a long time.
        expireDateTips: '如果未设置过期日期，则该值将长期有效。',
      },
      searchItems: '搜索条目数据',
      // Current Items Summary
      currentItemsSummary: '当前条目数据汇总',
      // 启用所选(Activate Selected)
      activateSelected: '启用所选',
      // 禁用所选(Deactivate Selected)
      deactivateSelected: '禁用所选',
      // 更新数据(Update Expire Date)
      updateExpireDate: '更新过期日',
      // 导出(Export)
      export: '导出',
      // 请选择条目数据(Please select items data)
      pleaseSelectItems: '请选择条目数据',
      // 请输入条目数据(Please enter items data)
      deactivate: '禁用',
      activate: '启用',
      // Set Expire Date
      setExpireDate: '设置过期日',
      // lastHitTime
      lastHitTime: '最后命中时间',
      confirmTips: '确定{operate}所选条目数据？',
      // Total
      total: '总计',
      copy: '复制',
      noExpiration: '长期',
      exampleFile: {
        title: '示例规则',
        subtitle: 'CSV文件填写说明',
        format: '使用',
        csv: '.csv',
        withColumns: '格式文件，包含以下列：',
        columns: '列名',
        columnNames: 'value,type,status,expire date,remarks',
        valueCanBe: '条目值可以是',
        // data or
        originalData: ' 原始数据 ',
        // or
        or: '或者',
        transactionOrEmail: '交易流水号',
        // addresses/suffixes
        transactionOrEmailDesc: '地址/后缀',
        typeShouldBe: '类型应为',
        typeC: '"C" - 原始值',
        typeCDesc: '（邮箱地址/后缀）',
        typeM: '"M" - 交易ID',
        typeMDesc: '（系统将查询关联原始数据）',
        statusShouldBe: '状态列应为',
        active: '"Active"',
        inactive: '"Inactive"',
        expiryDate: '过期日期可选项，格式：',
        dateFormat: 'YYYY-MM-DD',
        allValues: '所有值必须为',
        plainText: '明文',
        noMasking: '（暂不支持掩码）',
      },
    },
    alert: {
      info: '预警信息',
      caseInfo: '预警信息',
      ethocaId: 'Ethoca ID',
      rdrId: 'Case ID',
      merchantOrderId: '商户订单号',
      alertType: '预警类型',
      caseType: '预警类型',
      resellerSubMerchantId: '代理子商户号',
      resellerSubMerchantIdInputTips: '用于识别商户的标识',
      billDesc: '账单描述',
      billingDescriptorInputTips: '公司名称或账单网址',
      alertTime: '预警时间',
      enrollmentTime: '报备日期',
      updateTime: '更新时间',
      lastUpdatedDate: '最近更新日期',
      updatedUser: '最近更新人',
      authTime: '交易时间',
      outcome: '处理状态',
      outcomeStatus: '处理状态',
      refundStatus: '退款状态',
      enrollmentStatus: '报备状态',
      alertAge: '预警时效',
      initiatedBy: '预警发起方',
      liability: '是否责任方',
      merchantIdentifier: '商户信息',
      ethocaMerchantId: 'Ethoca 商户号',
      integratorMemberId: '集成商ID',
      transactionInfo: '交易信息',
      amount: '交易金额',
      currency: '交易币种',
      merchant: '商户名称',
      descriptor: '账单描述',
      arn: 'ARN',
      BIN: 'BIN',
      CAID: 'CAID',
      DBA: 'DBA',
      MCC: 'MCC',
      BINInputTips: 'Acquirer ID',
      CAIDInputTips: 'Card Acceptor ID',
      DBAInputTips: '公司名称或账单网址',
      MCCInputTips: 'MCC',
      preDisputeServiceInputTips: '拒付预警的来源服务',
      BINInputTips2: '收单BIN',
      MCCInputTips2: '提交的MCC可能与预警交易的MCC不同',
      resellerSubMerchantIdInputTips2: '用于标记和区分预警归属的商户标识',
      ARNInputTips: '存在交易时必填',

      outcomeUpdatedTime: '最后处理时间',
      caseReceivedDate: '接收预警日期',
      pricingTier: '定价等级',
      updateDate: '更新日期',
      submitEnrollment: '提交开通',
      withdrawEnrollment: '撤回开通',
      submitDisenrollment: '提交关闭',
      withdrawDisenrollment: '撤回关闭',
      issuer: '发卡行',
      cardNumber: '银行卡号',
      transactionType: '交易所属业务类型',
      authCode: '交易授权编码',
      transactionId: '交易编号',
      chargebackInfo: '拒付信息',
      chargebackReasonCode: '拒付原因编码',
      chargebackAmount: '拒付金额',
      chargebackCurrency: '拒付币种',
      outcomeInfo: '处理信息',
      caseAmount: '预警金额',
      caseCurrency: '预警币种',
      reasonCode: '预警原因编码',
      caseSource: '预警来源',
      caseStatus: '处理状态',
      caseStatusCode: '处理状态编码',
      caseRuleType: '规则类型',
      caseRuleName: '规则名称',
      rdrPartnerName: '合作伙伴名称',
      rdrPartnerID: '合作伙伴ID',
      rdrClientName: '客户名称',
      rdrClientID: '客户ID',
      rdrMerchantName: 'RDR商户名称',
      rdrMerchantID: 'RDR商户号',
      rdrContact: '联系方式',
      authDate: '交易日期',
      caseAuthorizationCode: '预警授权编码',
      cardBin: '银行卡BIN',
      cardLastFour: '银行卡末4位',
      paymentType: '支付方式',

      ethocaAlertDetails: 'Ethoca 预警详情',
      ethocaEnrollmentDetails: 'Ethoca 报备详情',
      rdrAlertDetails: 'RDR 预警详情',
      rdrEnrollmentDetails: 'RDR 报备详情',
      alertDate: '预警日期',
      cardHash: 'SHA1 Hashed Card Number',
      merchantMid: 'Merchant Descriptor/MID',
      source: 'Source',
      refundedOrNotSettled: 'Refunded/Not Settled',
      partiallyStoppedAmount: 'Partially Stopped Amount',
      comments: '审批意见',
      existingOutcome: 'Existing Outcome',
      existingComments: 'Existing Comments',
      outcomeUpdatedDateOrTime: 'Outcome Updated Date/Time',
      outcomeUpdatedBy: 'Outcome Updated By',
      bin8: 'BIN8',
      preDisputeService: '预警服务',
      addEthocaEnrollment: '新增 Ethoca 报备',
      editEthocaEnrollment: '编辑 Ethoca 报备',
      addRdrEnrollment: '新增 RDR 报备',
      editRdrEnrollment: '编辑 RDR 报备',
      note: '备注',
      enrollmentContent: '报备内容',
      alertReceived: '收到预警',
      outcomeSubmitted: '提交处理',
      initiateActivation: '发起开通',
      pendingActivation: '待开通',
      activing: '开通中',
      actived: '已开通',
      activeFailed: '开通失败',
      initiateClose: '发起关闭',
      pendingClose: '待关闭',
      closing: '关闭中',
      closed: '已关闭',
      alertBatchOperateTips: '处理 <b>{count}</b> 条，重复处理 <b>{duplicates}</b> 条<br>仅首次提交的预警处理终态会被发送至发卡行',
    },
    checkout: {
      explanation1: '1、针对卡支付，只允许设置最高优先级或最低优先级；',
      explanation2: '2、除卡以外的支付方式的优先级，可拖拽记录调整优先级，越靠上的记录，在收银台展示越靠前；',
      allDesc: 'ALL：除具体国家以外的国家',
      card: '卡',
      highestPriority: '优先级最高',
      lowestPriority: '优先级最低',
      cardSort: '卡种排序',
      addCardSort: '添加卡种排序',
      addSort: '添加排序',
      editSort: '编辑排序',
      addBrand: '新增品牌',
      editBrand: '编辑品牌',
      viewBrand: '品牌详情',
      brandName: '品牌名称',
      logo: 'Logo',
      mainColor: '主色',
      useWebsite: '应用于以下网站',
      colorSelectTip: '设置按钮以及选中时的颜色',
      useWebsiteTip: '1、’所有网站‘表示当前及未来创建的所有网站都使用该品牌信息；<br/> 2、不支持既应用于‘所有网站’又应用于具体的网站（即：同一个网站只能和一个品牌关联）；',
      noBrandTip: '您还没有设置品牌哦，快去添加您的品牌吧~',
      pay: '支付',
      deleteBrandConfirm: '确定删除该品牌吗？删除后，对应网站的品牌设置将失效。',
      brandLogoTip: 'logo图片的要求，至少为130*130像素，大小不超过500kb。支持的格式为JPG和PNG。',
      allWebsite: '所有网站',
      websiteErrorTip: '不支持既应用于‘所有网站’又应用于具体的网站（即：同一个网站只能和一个品牌关联）',
      isDisplayOrderNo: '收银台展示商户订单号',
      viewCancelBtn: '收银台取消按钮',
      cancelReturn: '返回商户页面',
      viewCountryBtn: '切换国家',
      customOptions: '自定义配置',
      selectCountry: '选择国家',
      orderNo: '订单号',
      logoAndNameEmptyTips: '品牌名称和logo必须填写任意一项',
      topDisplayOrderTips: '顶部展示顺序：LOGO-名称-网址。品牌未设置时显示商铺网址。',
    },
    currency: {
      CNY: '人民币',
      JPY: '日元',
      GBP: '英镑',
      CHF: '瑞士法郎',
      CAD: '加拿大元',
      HKD: '港币',
      FIM: '芬兰马克',
      IEP: '爱尔兰镑',
      LUF: '卢森堡法郎',
      PTE: '葡萄牙埃斯库多',
      IDR: '印尼盾',
      NZD: '新西兰元',
      SUR: '俄罗斯卢布',
      KRW: '韩国元',
      USD: '美元',
      EUR: '欧元',
      DEM: '德国马克',
      FRF: '法国法郎',
      AUD: '澳大利亚元',
      ATS: '奥地利先令',
      BEF: '比利时法郎',
      ITL: '意大利里拉',
      NLG: '荷兰盾',
      ESP: '西班牙比塞塔',
      MYR: '马来西亚林吉特',
      PHP: '菲律宾比索',
      SGD: '新加坡元',
      THB: '泰铢',
      BRL: '巴西雷亚尔',
    },
    currencyDesc: {
      CNY: '人民币',
      JPY: '日元',
      GBP: '英镑',
      CHF: '瑞士法郎',
      CAD: '加拿大元',
      HKD: '港币',
      FIM: '芬兰马克',
      IEP: '爱尔兰镑',
      LUF: '卢森堡法郎',
      PTE: '葡萄牙埃斯库多',
      IDR: '印尼盾',
      NZD: '新西兰元',
      SUR: '俄罗斯卢布',
      KRW: '韩国元',
      USD: '美元',
      EUR: '欧元',
      DEM: '德国马克',
      FRF: '法国法郎',
      AUD: '澳大利亚元',
      ATS: '奥地利先令',
      BEF: '比利时法郎',
      ITL: '意大利里拉',
      NLG: '荷兰盾',
      ESP: '西班牙比塞塔',
      MYR: '马来西亚林吉特',
      PHP: '菲律宾比索',
      SGD: '新加坡元',
      THB: '泰铢',
      BRL: '巴西雷亚尔',
      VND: '越南盾',
      MXN: '墨西哥比索',
      CNH: '离岸人民币',
    },
    developer: {
      alertNotifyTitle: '拒付预警报备通知',
      alertNotifyTips: '预警报备状态发生变更时发送通知',
      notifyStatus: '通知状态',
      selectNotifyType: '选择通知方式:',
      notifyType: '通知方式',
      webhook: 'Webhook',
      email: '邮箱',
      alertFailureNotifyTitle: '拒付预警失效通知',
      alertFailureNotifyTips: '预警报备超过180天无预警产生时发送通知',
      ethocaAlertTitle: 'Ethoca 预警通知',
      ethocaAlertTips: 'Ethoca 拒付预警通知',
      rdrAlertTitle: 'RDR 预警通知',
      rdrAlertTips: 'RDR 拒付预警通知',
      enrolling: '开通中',
      enrolled: '已开通',
      enrollmentFailed: '开通失败',
      disenrolling: '关闭中',
      disenrolled: '已关闭',
      fraudNotifyTitle: '欺诈通知',
      fraudNotifyTips: '由发卡行标记、卡网络发送的交易欺诈通知',
    },
    register: {
      // 摘要
      summary: '摘要',
      companyType: '公司类型',
      companyDetails: '公司详情',
      companyRepresentative: '公司代表',
      companyOwner: '公司所有人',
      websiteOrApplication: '网站/应用',
      bankAccount: '银行账户',
      status: '审核并完成',
      businessLocation: '公司所在地',
      typeOfBusiness: '公司类型',
      businessTypeTips: '请选择一个选项',
      company: '有限公司',
      partnership: '合伙业务',
      soleProprietorship: '独资经营',
      'limited_liability_partnership/LLP': '有限责任合伙/LLP',
      unincorporated_partnership: '非法人合伙',
      private_company: '私人公司',
      other: '其他/我不确定',
      submit_and_review: '请检查并提交',
      pleaseCheckAndSubmit: '劳烦检查并确认您的信息。',
      submitAgreement: '同意并提交',
      // 服务协议有个链接点击，如何使用多语言，能使用html么
      submitAgreementTips: '提交本表，即表示您同意我们的<a href="https://www.onerway.com/privacy?lang=zh" class="service-agreement">服务协议</a>，同意接收发送的短信和邮件，且您确认所提供的信息是完整和准确的。',
      addAll: '添加所有人',
      validaterBusiness: '验证您的业务',
      errorTitle: {
        input: '英文字母+数字+半角标点',
      },
      validateBusiness: {
        companyType: {
          descript1: '我们首先填写一些基本信息',
          descript2: '选择您的地点和业务类型以开始。',
        },
        companyDetails: {
          descript1: '请提供进件公司信息',
          descript2: 'Onerway 收集该信息的目的是更好的服务您的业务。',
        },
        companyRepresentative: {
          descript1: '验证您的公司代表身份',
          descript2: '此表须由对您公司业务有控制权或管理权的人来填写。如果您不是，请让适当的人来填写。',
        },
        companyOwner: {
          descript1: '公司所有人',
          descript2: '根据法规要求，我们需要收集并验证在您的公司拥有主要所有权（拥有25%或更多）的任何人的信息。',
        },
        websiteOrApplication: {
          descript1: '网站/应用',
          descript2: 'Onerway 收集该信息的目的是更好的评估并服务您的业务。',
        },
        bankAccount: {
          descript1: '添加您的银行账户以接收提现',
          descript2: '提现是指从 Onerway 向您的银行账户转账。',
        },
      },
      companType: {
        referrer: '推荐人',
        referrer_placeHolder: '您加入Onerway的推荐人',
      },
      businessDetails: {
        legal_business_name: '法定公司名称',
        company_registration_number: '公司注册号码',
        company_registration_date: '公司注册日期',
        business_name: '公司营业名称',
        registered_business_address: '公司注册地址',
        business_phone_number: '公司电话号码',
        upload_company_certificates: '上传公司资料',
        legal_business_name_input_placeHolder: '与税号关联的名称一致',
        area: '城市/区域',
        location: '所在地',
        district: '地区',
        address_line_1: '地址第 1 行',
        address_line_2: '地址第 2 行',
        postal_code: '邮政编码',
        certificate_of_incorporation: '公司注册证书',
        business_registration_certificate: '公司营业登记证书',
        'company_NNC1/NAR1': '公司 NNC1/NAR1',
        explanation_of_shareholding_structure: '股权结构说明',
        articles_of_association: '公司章程',
        extra_document_1: '补充资料 1',
        extra_document_2: '补充资料 2',
        extra_document_3: '补充资料 3',
        extra_document_4: '补充资料 4',
        extra_document_5: '补充资料 5',
        upload_limit: '最大不超过10M，限定格式JPG、PNG、JPEG',
        upload_limit_50: '最大不超过50M，限定格式JPG、PNG、JPEG',
      },
      companyRepresentative_desc: {
        legalName: '法定名称',
        legalName_firstName: '名字',
        legalName_lastName: '姓',
        email_address: '邮件地址',
        job_title: '职位',
        birthDate: '出生日期',
        home_address: '家庭住址',
        phone_number: '电话号码',
        personal_id_numbe: '个人身份证件号码',
        personal_id_numbe_input_placeHolder: '政府签发的个人身份证件号码',
        birthDUpload_Personal_id_imagesate: '上传证件影像',
        job_input_tips: 'CEO, 经理, 合伙人',
        passport: '护照',
        // 微信号
        wechat: '微信号',
        wechat_input_placeHolder: '请输入微信号',
        legalName_required: '姓名不能为空',
      },
      websiteOrApplication_desc: {
        business_website: '业务网站',
        duration_of_operation: '已运营时间',
        business_website_type: '网站类型',
        website_default_domain: '原始网址',
        'industry/Business_category': '所属行业',
        'monthly_trading_volume (USD)': '月交易额（USD）',
        monthly_dispute_rate: '拒付率',
        monthly_refund_rate: '退款率',
        market: '业务面向市场',
        upload_business_proofs: '上传业务证明',
        'Transaction statements (last 3 months)': '交易报表（近三月）',
        'Screenshots of business platforms': '业务平台截图',
        placeholder: {
          'industry/Business_category': '请选择您的行业',
          website_default_domain: '例如：xxx.myshopify.com',
        },
        options: {
          duration_of_operation: {
            new: '新网站',
            less_than_1_year: '1年以下',
            '1_to_3_years': '1年～3年',
            more_than_3_years: '3年以上',
          },
        },
      },
      bankAccount_desc: {
        bank_name: '账户持有者名称',
        bank_address: '开户银行',
        // 开户银行地址
        bank_account_location: '开户银行地址',
        Currency: '币种',
        bank_account_number_HK: '账号',
        bank_account_number_UK: 'IBAN账号',
        'Confirm account number': '确认账号',
        'Upload bank statement': '上传银行账单',
        // 开户证明
        'Account Opening Proof': '开户证明',

        'Upload extra proofs': '上传补充资料',
        placeholder: {
          bank_name: '须与法定公司名称一致',
          bank_address: '搜索您的开户银行/ SWIFT Code',
          Currency: '请选择业务币种',
          bank_account_number_HK: '000123-456',
          bank_account_number_UK: 'GB61CLRB12345678909876',
          upload_extra_proofs: '开户银行与公司所在地不同时，请补充开户银行所在地的公司资料',
          bank_account_location: '请输入开户银行地址',
        },
        descript: {
          application_submitted: '申请已提交',
          descript_content: '您的申请已提交，Onerway的工作人员正在审核中。我们可能就材料的完整性、真实性，通过你的注册邮箱或公司代表联系方式联系您或您的公司代表。',
          descript_tips: '审核一旦完成，我们将第一时间通知您，谢谢您的配合。',
        },
      },
      marketOptions: {
        hottest: '最热门',
        otherMarket: '其它市场',
        northAmerica: '北美洲',
        europe: '欧洲',
        eastAsia: '东亚',
        southeastAsia: '东南亚',
        middleEast: '中东地区',
        latinAmerica: '中南美洲',
        africa: '非洲',
        ceania: '南极洲',
      },
    },
    countryList: {
      HK: '中国香港特别行政区',
      UK: '英国',
    },
    // marketOptions: {
    //   northAmerica: 'North America',
    //   europe: 'Europe',
    //   eastAsia: 'East Asia',
    //   southeastAsia: 'Southeast Asia',
    //   middleEast: 'Middle East',
    //   latinAmerica: 'Latin America',
    //   frica: 'Africa',
    //   ceania: 'Oceania',
    // },

    settingsSuccessfulTip: '设置成功',
    settingsFailedTip: '设置失败',
    downloadSuccessfulTip: '下载成功',
    downloadFailedTip: '下载失败',
    uploadSuccessfulTip: '上传成功',
    uploadFailedTip: '上传失败',
    submitSuccessfulTip: '提交成功',
    submitFailedTip: '提交失败',
    operateSuccessfulTip: '操作成功',
    emptyUploadFileTip: '请选择上传文件',
    supportFileTip: '支持{type}格式',
    supportFileErrorTip: '只能上传{type}文件',
    settings: {
      authCapture: {
        title: 'Auth-Capture设置',
        saveBtn: '保存修改',
        desc: '以下设置仅适用于授权类(Auth)交易',
        captureRadio: '自动捕获(Capture)',
        voidRadio: '自动取消(Void)',
        notice: '提示',
        leaveTips: '当前修改未保存。是否持续跳转新页面？',
        leaveConfirmText: '仍要离开',
        leaveCancelText: '前往保存',
      },
    },
    jumio: {
      sumbitTips: '所有企业主的人脸认证全部通过后，请提交此页以完成人脸认证。',
      sumbitBtn: '提交认证信息',
      sumbitLater: '稍后提交',
      Title: '企业主',
      leftTitle: '提交人脸认证信息',
      jumioTipsTitle: '如果已完成所有人脸认证，请点击底部提交',
      subTitle: '请确保所提供文件的真实、完整、有效和清晰度 有多个受益人时，请添加持股超过25%的个人。',
      add: '添加企业主',
      adds: '新增',
      status: {
        pending: '待认证',
        approved: '已认证',
        rejected: '认证失败',
        pending_scan: '待扫描',
      },
      authenticated: '认证日期',
      email: '邮件认证',
      emailSendSuccess: '邮件发送成功',
      immediately: '立即认证',
      addTitle: '新增企业主',
      addSubTitle: '最多可添加5位董事和5位受益人',
      refuseTitle: '删除企业主',
      refuseTips: '该操作将删除该人员的全部记录，认证信息（若有）也将删除。是否删除？',
      editTitle: '编辑企业主',
      atLeast: '请至少添加1位董事和1位受益人',
      allStauts: '企业主须全部完成人脸认证才允许提交。内容已自动保存，认证状态可能延迟更新，您也可以退出界面，稍后状态更新后，再次点击提交按钮。',
      jumioPopTitle: '请扫描二维码完成人脸认证',
      jumioTime: '请在 <span class="time" style="color:#6655F7">{time}</span> 内完成人脸认证',
      jumioTips: '注意',
      jumioTipsContent: '由于系统延迟认证状态可能延后更新，您可以关闭此弹框继续填写并提交表单。',
      jumioTipsContent2: '如果二维码过期，请关闭此弹框再次获取认证二维码。',
      emailPoptitle: '包含人脸认证的链接将以邮件的形式发送给对方。',
      emailLabel: '认证人邮箱',
      emailWarn: '{time} 向 {email} 发送了认证请求邮件，如更改邮箱或未收到邮件，请确认邮箱后，重新发送。',
      errTitle: '认证不通过，请修改信息',
      delSus: '删除成功',
      infoTitle: '人脸认证',
      authPass: '已完成',
    },
    guide: {
      activatePayouts: '付款业务开通',
      provide1: '我们提供全面的解决方案',
      provide2: '实时支付（RTP)',
      provide3: '支持20多种主要全球货币。在您完成支付服务激活后，我们将自动为您建立五个默认货币账户：',
      provide4: '美元、欧元、英镑、港元和离岸人民币。',
      activateBtn: '立即开通付款业务',
      info1Title: '快速到账',
      info1Desc: '支付处理迅速，<br/>最快可实现24小时内资金到账',
      info2Title: '多币种支持',
      info2Desc: '支持超过20种主流货币，<br/>满足您的全球业务需求',
      info3Title: '实时汇率',
      info3Desc: '提供实时市场汇率，<br/>确保您获得最优惠的兑换服务',
      info4Title: '安全可靠',
      info4Desc: '采用银行级安全措施，<br/>保障您的资金安全',
    },
    // 欺诈通知模块 / Fraud notification module
    fraudNotification: {
      title: '欺诈通知',
      notificationId: '通知ID',
      notifiedTime: '通知发起时间',
      receivedTime: '通知接收时间',
      fraudType: '欺诈类型',
      transactionId: '源交易流水号',
      transactionAmount: '源交易金额',
      paymentMethod: '支付方式',
      disputePresence: '源交易拒付状态',
      chargebackId: '拒付流水号',
      refundType: '源交易退款类型',
      refundId: '退款流水号',
      received: '报告接收时间',
      fraudNotificationTips: '欺诈通知（Notifications of Fraud）来自于卡组织，这些通知由发卡机构生成，用于标记它们怀疑可能是欺诈的交易。请注意，接收到欺诈通知时，欺诈/拒付可能已经发生。',
    },
    // 欺诈通知详情页面多语言配置 / Fraud notification details page i18n configuration
    fraudNotificationDetails: {
      pageTitle: '详情', // Fraud Notification Details
      notificationDetails: '欺诈通知信息', // Notification Details
      transactionDetails: '源交易信息', // Transaction Details
      id: 'ID', // ID
      notifiedTime: '发起时间', // Notified Time
      notifiedTimeTip: '欺诈通知存在多个来源，时间格式可能存在差异。', // Since NoF come from multiple sources, the time format may vary.
      receivedTime: '接收时间', // Received Time
      fraudType: '欺诈类型', // Fraud Type
      amount: '金额', // Amount
      currency: '币种', // Currency
      transactionId: '流水号', // ID
      transactionTime: '交易时间', // Time
      paymentMethod: '支付方式', // Payment Method
      chargebackStatus: '拒付状态', // Chargeback Status
      chargebackId: '拒付ID', // Chargeback ID
      refundType: '退款类型', // Refund Type
      refundId: '退款ID', // Refund ID
      invalidId: 'ID参数无效', // Invalid ID parameter
    },
  },

  ...zhLocale,
};
